import { Gantt } from "gantt-task-react-coloredcow";
import "gantt-task-react-coloredcow/dist/index.css";
import { get, isFunction } from "lodash";
import moment from "moment";
import PropTypes from "prop-types";
import queryString from "query-string";
import React, { Component } from "react";
import {
  Button,
  ButtonToolbar,
  Col,
  Container,
  DropdownButton,
  Dropdown,
  Form,
  Image,
  Row,
  Modal
} from "react-bootstrap";
import { Loader, LoaderPage } from "../../component/Loader";
import { DatePicker } from "../../component/DatePicker";
import {
  PATHS,
  STATUS,
  DOCUMENT_FORMATS,
  ERROR_MSG,
  ISSUE_STATUS,
  IIG_PATHS
} from "../../constant";
import {
  dateFormat,
  formatNumber,
  getLocalstorage,
  GROUP_KEYS,
  handleLanguage,
  handlePaste,
  isValidArray,
  Project_Stage_Helper,
  scrollToPosition,
  projectFormLabel,
  replaceCharacterWith
} from "../../helper";
import { connect } from "react-redux";
import { Redirect, withRouter } from "react-router-dom";
import ReactToPrint, { PrintContextConsumer } from "react-to-print";
import { toast } from "react-toastify";
import { bindActionCreators } from "redux";
import {
  clearIssueList,
  getIssueList,
  getDivisionList
} from "../../actions/common.action";
import { fetchAllProjectStatus } from "../../actions/mis.action";
import {
  changeProjectStatus,
  getMilestoneGanttChartData,
  getProjectComments,
  getProjectDetails,
  getProjectNoteAction,
  getProjectTimelineData,
  getProjectUpdates,
  saveProjectCommentAction,
  saveProjectNoteAction
} from "../../actions/projectDetail.action";
import CircleWithExclamation from "../../assets/circle-with-exclamation.svg";
import IconPin from "../../assets/icon-pin.png";
import leftArrow from "../../assets/projectTimeline/left-arrow.png";
import rightArrow from "../../assets/projectTimeline/right-arrow.png";
import { Field } from "../../component";
import DisplayByPermission from "../../component/DisplayByPermission";
import TooltipComponent from "../../component/TooltipComponent";
import { ConfirmationComponent } from "../ConfirmationComponent";
import CreateProjectForm from "../createProject/CreateProjectForm";
import EditProject from "../createProject/EditProject";
import { setDraftDataForMilestone } from "../createProject/helper";
import PreviewMilestone from "../createProject/Milestones/PreviewMilestone";
import { ModalIIGUpdateProjectDisabled } from "../createProject/ModalIIGUpdateProjectDisabled";
import HistoryAndComment from "../IssueHistoryAndComments/History";
import Comment from "../IssueHistoryAndComments/Comment";
import History from "../IssueHistoryAndComments/History";
import PermissionHOC from "../PermissionHOC";
import ConfirmationCheckbox from "./ConfirmationCheckbox";
import IssueTile from "../issueList/IssueTile";
import {
  CommentComponent,
  //DisplayAttachments,
  NoteComponent,
  ReadMore,
  RedirectUser,
  UploadAttachmentsWithTitleComponent
} from "../reusableComponent";
import { DisplayAttachments } from "../reusableComponent/displayAttachments/indexForward";
import { ToggleBtn } from "../togglebtn";
import { iigBaseUrl } from "../../globalConfig";
import MilestoneTooltipContent from "./MilestoneTooltipContent";
import ProjectDetailsSideBar from "./ProjectDetailsSideBar";
import ProjectMilestoneDetails from "./ProjectMilestoneDetails";
import {
  getTasksFromBucketData,
  taskListDateHeader,
  taskListHeader,
  taskListTable
} from "./ProjectMilestoneGanttChart";
import ProjectOverview from "./ProjectOverview";
import ProjectTimeline from "./projectTimeline";
import ProjectAddDecisionModal from "./ProjectAddDecisionModal";
import { getProjectDecisionDetailsAction } from "../../actions/projectDetail.action";
import { ProjectDetailsExtension } from "./ProjectDetailsExtension";
import { successToastStyle, errorToastStyle } from "../../customToast";
import htmlToFormattedText from "html-to-formatted-text";
import Forma from "../../assets/Forma 1.svg";
import { modifyDataForEdit } from "../createProject/helper";
import {
  setProjectDataAction,
  clearProjectDataAction
} from "../../actions/formData.action";
import { getProjectDetailByIdAction } from "../../actions/createProject.action";
import CustomDropdown from "../reusableComponent/Dropdown/CustomDropdown";
import {
  getCostDistributionData,
  getProjectDetail
} from "../../services/apiServices";
import request from "../../services/requestService";
import Dropdownarrow from "../../assets/new-grey-drop-down-arrow.svg";
import NoDataFoundIcon from "../../assets/NO_DATAFOUND.png";
import cabinet_milestone_logo from "../../assets/cabinet_milestone_logo.svg";
import accordian_down_arrow from "../../assets/accordian_down_arrow.svg";
import accordian_up_arrow from "../../assets/accordian_up_arrow.svg";
import pmg_white_logo from "../../assets/pmg_white_logo.svg";
class ProjectDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ProjectDetails: false,
      show: false,
      ProjectActions: false,
      error: {},
      status: "",
      commentUpdatesData: [],
      projectIdStatus: false,
      readMoreToggle: false,
      isAllApiLoaded: STATUS.LOADING,
      comment: "",
      toggleCommentWindow: false,
      isCommentApiLoading: false,
      showTimeline: true,
      showBtn: false,
      showEditMilestone: false,
      showMilestone: true,
      terminatedDate: null,
      isProjectDetailsTabActive: true,
      iigProjectReferenceId: null,
      milestoneData: null,
      milestoneTabs: false,
      selectedViewMode: "Month",
      languageError: null,
      pasteError: false,
      pastedText: "",
      showCommentError: false,
      showAddDecisionModal: false,
      projectAddedDecisionData: {},
      isIssueLoaded: false,
      projectNotemodalClose: false,
      projectNotemodifyDate: "",
      projectNoteuserId: "",
      projectNoteuserName: "",
      isViewOnly: false,
      underMaintenance: false,
      EditLoading: false,
      march24DTO: null,
      superAdminPMGUserAdmin: false,
      costDistributionData: {},
      options: ["Phase 1", "phase 2"],
      selected: { key: "", title: "Select Phase" },
      phaseIndex: null,
      activeIndex: 0,
      isOpen: false,
      pmgAccordion: true,
      editProjectData: "",
      showPopup: false,
      reason: "",
      milestoneName: "",
      selectedMilestone: ""
    };
    scrollToPosition({ top: 0 });
    this.myTimelineRef = React.createRef();
    this.slideLeftRef = React.createRef();
    this.slideRightRef = React.createRef();
  }
  toggleAccordion = () => {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen
    }));
  };
  pmgToggleAccordion = () => {
    this.setState(prevState => ({
      pmgAccordion: !prevState.pmgAccordion
    }));
  };
  issueListApiCall() {
    try {
      const {
        location: { search },
        projectData
      } = this.props;
      const params = {};
      const { projectId } = queryString.parse(search) || {};
      let data = get(projectData, "data", null);
      let isProjectAwardedByState =
        data && data.sponsoredByCategory === GROUP_KEYS.STATE;

      if (projectId) {
        this.setState(
          {
            issueListApiStatus: STATUS.LOADING,
            issueListDTO: null
          },
          async () => {
            const response = await getIssueList(undefined, {
              ...params,
              projectId,
              projectDetail: true,
              groupCategory: isProjectAwardedByState
                ? GROUP_KEYS.STATE
                : GROUP_KEYS.CENTRAL
            });
            if (response) {
              const { status, message, data } = response;
              if (status) {
                this.setState({
                  issueListDTO: data,
                  issueListApiStatus: STATUS.SUCCESS,
                  isIssueLoaded: true
                });
              } else {
                this.setState({
                  issueListApiStatus: STATUS.ERROR
                });
              }
            }
          }
        );
      }
    } catch (e) {
      //console.log("Error while fetching error", e);
    }
  }

  componentDidMount() {
    this.initialApiCall();
  }
  openReasonModal = (milestoneName, reasonForDelay) => {
    this.setState({
      showPopup: true,
      selectedMilestone: milestoneName,
      reason: reasonForDelay
    });
  };
  onModalHide = () => {
    this.setState({
      showPopup: false,
      reason: "",
      milestoneName: ""
    });
  };
  initialApiCall = () => {
    const {
      getProjectDetails,
      location,
      fetchAllProjectStatus,
      getProjectTimelineData,
      history,
      calledFromIssueDetail = false,
      getMilestoneGanttChartData,
      getProjectDecisionDetailsDispatch
    } = this.props;
    const { projectId } = queryString.parse(location.search);
    const path = location.pathname;
    getProjectDetails(undefined, { id: +projectId }).then(resp => {
      if (resp && !resp.status && !calledFromIssueDetail) {
        if (path !== "/issue-detail") {
          history.push(PATHS.PROJECT_LIST);
        }
      }
      this.setState({
        showEditMilestone: false,
        showMilestone: true,
        isProjectDetailsTabActive: true,
        iigProjectReferenceId: resp.data.iigProjectReferenceId,
        getProjectDetails: resp.data,
        isViewOnly: resp.data.viewOnly
      });
      this.getProjectForCards(resp.data);
    });
    getProjectTimelineData(projectId);

    getMilestoneGanttChartData(projectId).then(response => {
      this.setState({
        milestoneData: response.data
      });
    });

    fetchAllProjectStatus();
    setTimeout(() => {
      this.shouldShowMoveBtn();
    }, 1000);
    this.getCommentAndUpdates("comment", projectId);

    getProjectDecisionDetailsDispatch(undefined, { id: +projectId }).then(
      response => {
        this.setState({ projectAddedDecisionData: response.data });
      }
    );

    const getCostData = request(
      getCostDistributionData({ projectId: projectId, active: true })
    );
    getCostData.then(resp => {
      this.setState({ costDistributionData: resp.data.data });
    });
    this.geteditProjectData(projectId);
  };
  geteditProjectData = async projectId => {
    const resp = await request(getProjectDetail(projectId));
    //console.log(resp.data.data)
    this.setState({ editProjectData: resp.data.data });
  };
  getProjectForCards = projectData => {
    const data = get(projectData, "bucketDataDTOList", []);
    const milestoneDataList = data
      .filter(
        item =>
          Array.isArray(item.milestoneTableDataList) &&
          item.milestoneTableDataList.length > 0
      )
      .reduce((maxList, item) => {
        return item.milestoneTableDataList.length > (maxList.length || 0)
          ? item.milestoneTableDataList
          : maxList;
      }, []);

    this.setState({ phaseIndex: milestoneDataList });
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (!prevState.showTimeline && this.state.showTimeline)
      setTimeout(() => {
        this.shouldShowMoveBtn();
      }, 1000);

    // // Check if previewData has changed
    // if (prevProps.previewData !== this.props.previewData) {
    //   // Set loadingStatus to true if previewData is null
    //   if (this.props.previewData === null) {
    //     this.setState({ EditLoading: true });
    //   } else {
    //     // Optionally, set loadingStatus to false if previewData is not null
    //     this.setState({ EditLoading: false });
    //   }
    // }
  }

  onProjectEdit = () => {
    const { callApiOnSuccess } = this.props;
    this.initialApiCall();
    isFunction(callApiOnSuccess) && callApiOnSuccess();
  };

  handleClose = () => {
    this.setState({ show: false, EditLoading: false });
  };

  handleShow = () => {
    this.setState({ show: true });
  };

  getDivisionsData = async sponsoringdeptId => {
    const divResp = await getDivisionList(undefined, sponsoringdeptId);
    const { data, status } = divResp;
    if (status) {
      this.setState({
        divisionData: data.data
      });
    }
  };

  handleUpdateShow = () => {
    const {
      projectData,
      setProjectDataDispatch,
      previewData,
      getProjectDetailByIdDispatch
    } = this.props;
    let data = get(projectData, "data", null);

    // Set loading to true before sending the request
    this.setState({ EditLoading: true }, async () => {
      if (data && data.sponsoredByid == 37) {
        if (data.sponsoringDepartment != null) {
          this.getDivisionsData(data.sponsoringDepartment.id);
        }
      }

      const resp =
        previewData ||
        (data && (await getProjectDetailByIdDispatch(undefined, data.id)));
      if (!previewData && resp) {
        const { data, status } = resp;

        if (resp) {
          const projectData = resp.data;
          let march24info = projectData.march24DTO;
          this.setState({
            march24DTO: march24info,
            superAdminPMGUserAdmin: projectData.superAdminPMGUserAdmin
          });
        }

        if (status) {
          data.divisionList = this.state.divisionData;
          const modifiedData = modifyDataForEdit(data);
          setProjectDataDispatch(modifiedData); // Call the dispatch function
          this.setState({ EditLoading: false, show: true });
        }
      }
    });
  };

  onHandleChecked = event => {
    this.setState({
      isIssueVerified: !event
    });
  };

  toggleProjectDetails = () => {
    this.setState(prevState => {
      return {
        ProjectDetails: !prevState.ProjectDetails
      };
    });
  };

  toggleProjectActions = () => {
    this.setState(prevState => ({
      ProjectActions: !prevState.ProjectActions,
      files: [],
      comment: "",
      status: "",
      error: {},
      languageError: false,
      pastedError: false
    }));
    this.issueListApiCall();
  };

  handleChange = (value, name) => {
    this.setState({ [name]: value, isIssueVerified: false }, () => {
      this.onError(name, value);
      if (window.event.inputType === "insertFromPaste") {
        this.pasteLanguage();
      }
    });
  };

  onError = (key, value) => {
    this.setState(prevState => ({
      error: {
        ...prevState.error,
        [key]: value
      }
    }));
  };

  validateError = () => {
    const { error, comment, status } = this.state;
    if (
      !error.comment ||
      get(error, "comment.error") ||
      (!error.status || get(error, "status.error"))
    ) {
      this.setState({
        showCommentError: true,
        languageError: false,
        pasteError: false,
        error: {
          status: {
            error: !status,
            message: !status && ERROR_MSG.DEFAULT_MSG
          },
          comment: {
            error: !comment,
            message: !comment && ERROR_MSG.DEFAULT_MSG
          }
        }
      });
    } else {
      this.setState(prevState => ({
        showCommentError: true,
        languageError: false,
        pasteError: false,
        showAlert: !prevState.showAlert
      }));
    }
  };

  onHandleSend = async () => {
    let {
      comment,
      status,
      files,
      terminatedDate,
      isIssueVerified = false
    } = this.state;
    const { projectData, callApiOnSuccess } = this.props;
    let data = get(projectData, "data", null);
    this.setState({
      isApiLoading: STATUS.LOADING
    });
    if (status === "") {
      status = get(data, "projectActionList[0]", "");
    }
    const response = await changeProjectStatus(undefined, {
      comment: htmlToFormattedText(comment),
      projectId: data && data.id,
      projectStatus: status,
      terminatedDate: terminatedDate,
      files: (files || []).map(value => +value.id),
      isIssueVerified
    });
    if (response) {
      const { data, status } = response;
      if (status) {
        this.initialApiCall();
        toast.success(
          <p className="toast-text-alignment">{data.message}</p>,
          successToastStyle
        );
        this.toggleProjectActions();
        isFunction(callApiOnSuccess) && callApiOnSuccess();
        this.setState({
          comment: "",
          status: get(data, "projectActionList[0]", [])
        });
        getProjectComments(undefined, get(projectData, "data.id")).then(
          resp => {
            if (resp && resp.data) {
              this.setState({
                commentUpdatesData: resp && resp.data.data
              });
            }
          }
        );
      } else {
        toast.error(
          <p className="toast-text-alignment">{data.message}</p>,
          errorToastStyle
        );
      }
    } else {
      toast.error(
        <p className="toast-text-alignment">
          {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
        </p>,
        errorToastStyle
      );
    }
    this.setState(prevState => ({
      showAlert: !prevState.showAlert,
      isApiLoading: STATUS.SUCCESS
    }));
  };

  getCommentAndUpdates = (type, id) => {
    try {
      // if both types is equal
      if (this.state.type === type) {
        return false;
      }
      // api according to its type
      const api = type === "comment" ? getProjectComments : getProjectUpdates;

      this.setState(
        {
          type,
          commentUpdatesData: [],
          isCommentAndUpdatesLoading: STATUS.LOADING
        },
        async () => {
          const response = await api(undefined, id);
          const { data } = response ? response.data : {};
          this.setState({
            commentUpdatesData: data,
            isCommentAndUpdatesLoading: STATUS.SUCCESS
          });
        }
      );
    } catch (error) {
      //console.error("Error while fetching commnets and updates");
    }
  };

  onToggleCommentSection = closemodal => {
    const {
      props: { projectData }
    } = this;
    this.setState(
      prevState => ({
        toggleCommentWindow: !prevState.toggleCommentWindow,
        isNoteApiLoading: true,
        addedComment: "",
        projectNotemodalClose: closemodal == "closemodal" ? null : true
      }),
      async () => {
        const response = await getProjectNoteAction(
          undefined,
          get(projectData, "data.id")
        );
        const { data } = response || {};
        this.setState({
          addedComment: data ? data.data.noteText : "",
          isNoteApiLoading: false,
          projectNotemodalClose: closemodal == "closemodal" ? null : false,
          projectNotemodifyDate: data.data.modifiedDate,
          projectNoteuserId: data.data.userId,
          projectNoteuserName: data.data.userName
        });
      }
    );
  };

  onChangeComment = addedComment => {
    this.setState({ addedComment });
  };

  onChangeNewComment = addedNewComment => {
    this.setState({ addedNewComment });
  };

  onToggleNewComment = () => {
    this.setState({
      showNewCommentModal: !this.state.showNewCommentModal
    });
  };

  onSubmitNewComment = filesArr => {
    const {
      state: { addedNewComment },
      props: { projectData }
    } = this;
    this.setState(
      {
        isCommentApiLoading: true
      },
      async () => {
        const response = await saveProjectCommentAction({
          projectId: get(projectData, "data.id"),
          comment: htmlToFormattedText(addedNewComment),
          files: (filesArr || []).map(value => {
            return +value.id;
          })
        });
        const { data } = response || {};
        data && data.status
          ? toast.success(
              <p className="toast-text-alignment">{data.message}</p>,
              successToastStyle
            )
          : toast.error(
              <p className="toast-text-alignment">
                {data ? data.error[0] : "Comment not saved."}
              </p>,
              errorToastStyle
            );
        if (data && data.status) {
          this.setState(
            {
              isCommentAndUpdatesLoading: STATUS.LOADING
            },
            async () => {
              const response = await getProjectComments(
                undefined,
                get(projectData, "data.id")
              );
              const { data } = response ? response.data : {};
              this.setState({
                commentUpdatesData: data,
                isCommentAndUpdatesLoading: STATUS.SUCCESS
              });
            }
          );
        }
        this.setState({
          addedNewComment: "",
          isCommentApiLoading: false,
          showNewCommentModal: false
        });
      }
    );
  };

  onSubmitComment = (fieldName, value) => {
    const {
      state: { addedComment },
      props: { projectData }
    } = this;
    this.setState(
      {
        isNoteApiLoading: true,
        projectNotemodalClose: true,
        addedComment: fieldName == "projectnote" ? value : null
      },
      async () => {
        const response = await saveProjectNoteAction(undefined, {
          projectId: get(projectData, "data.id"),
          note:
            fieldName == "projectnote"
              ? this.state.addedComment
              : htmlToFormattedText(addedComment)
        });
        const { data } = response || {};
        data && data.status
          ? toast.success(
              <p className="toast-text-alignment">{data.message}</p>,
              successToastStyle
            )
          : toast.error(
              <p className="toast-text-alignment">
                {data ? data.message : "Note not saved."}
              </p>,
              errorToastStyle
            );
        this.setState({
          addedComment: "",
          isNoteApiLoading: false,
          toggleCommentWindow: false,
          projectNotemodalClose: false
        });
      }
    );
  };

  onToggleAttachment = index => {
    this.setState(prevState => {
      return {
        toggleAttachementDisplay: !prevState.toggleAttachementDisplay
      };
    });
  };

  onProjectMilestoneByChangeResponsive = e => {
    this.setState({
      milestoneTabs: e.target.checked
    });
  };

  onProjectMilestoneDate = name => {
    this.setState({
      milestoneDatesTabs: name
    });
  };
  onBlur = value => {};
  onViewModeChange = e => {
    this.setState({
      selectedViewMode: e.target.value
    });
  };

  onSuccessUploadOfAttachments = async data => {
    try {
      this.setState(prevState => ({ files: [...prevState.files, data] }));
    } catch (error) {
      //console.error(error.message);
    }
  };

  onRemoveFile = ({ id }) => {
    try {
      this.setState(prevState => ({
        files: prevState.files.filter(val => val.id !== id)
      }));
    } catch (error) {
      //console.log(`Error while deleting the image ${error.message}`);
    }
  };

  shouldShowMoveBtn = () => {
    let scrollWidth =
      this.myTimelineRef.current && this.myTimelineRef.current.scrollWidth;
    let clientWidth =
      this.myTimelineRef.current && this.myTimelineRef.current.clientWidth;
    let showBtn = !!(scrollWidth > clientWidth);
    this.setState({ showBtn }, () => {
      if (this.slideRightRef.current && this.myTimelineRef.current) {
        this.slideRightRef.current.onclick = () => {
          this.myTimelineRef.current.scrollLeft += 200;
        };
      }

      if (this.slideLeftRef.current && this.myTimelineRef.current) {
        this.slideLeftRef.current.onclick = () => {
          this.myTimelineRef.current.scrollLeft -= 200;
        };
      }
    });
  };

  handleTerminatedDate = value => {
    let _terminatedDate = value ? moment(value).valueOf() : null;
    this.setState({ terminatedDate: _terminatedDate });
  };

  showProjectDetailsWithIIG = () => {
    this.setState({ isProjectDetailsTabActive: false });
  };

  showProjectDetails = () => {
    this.setState({ isProjectDetailsTabActive: true });
  };

  getProjectDetailsHTML = (data, projectCost, colWidth, isUserStatePMG) => {
    const isCenterSponsored = get(data, "sponsoredByCategory") === "CENTRAL";
    const iigPayload = get(data, "iigPayload");
    let iigReferenceId = get(data, "iigProjectReferenceId", null);
    let actualPhysicalProgress = get(data, "projectCompletionDTO.percentage");
    let plannedPhysicalProgress = get(data, "iigPlannedPhysicalProgress");
    let plannedFinancialProgress = get(data, "iigPlannedFinancialProgress");
    let actualFinancialProgress = get(
      data,
      "projectCompletionDTO.financialPercentage"
    );
    return (
      <Col lg={colWidth} className="details-table">
        {get(data, "description") ? (
          <Row className="">
            <Col lg={12}>
              {projectFormLabel(
                get(data, "sponsoredByid"),
                "description",
                "Brief Project Description"
              )}
            </Col>
            <Col lg={12} className="project-brief">
              <ReadMore
                content={get(data, "description")}
                descriptionWeight={true}
              />
            </Col>
          </Row>
        ) : null}
        {get(data, "cin") ? (
          <Row>
            <Col lg={5}>CIN Number</Col>
            <Col lg={7}>{get(data, "cin") || "NA"}</Col>
          </Row>
        ) : null}
        <Row>
          <Col lg={5}>Project Cost (in Crores)</Col>
          <Col lg={7}>
            {parseFloat(projectCost) !== 0 ? `₹ ${projectCost} Cr.` : "N/A"}
          </Col>
        </Row>
        <ProjectDetailsExtension
          data={data}
          sponsoredByid={get(data, "sponsoredByid")}
          fieldName={"project_cost_share"}
        />
        {get(data, "createdBy") ? (
          <Row>
            <Col lg={5}>Created By</Col>
            <Col lg={7}>{get(data, "createdBy", null)}</Col>
          </Row>
        ) : null}
        {get(data, "sponsoredBy") ? (
          <Row>
            <Col lg={5}>Sponsored By</Col>
            <Col lg={7}>{get(data, "sponsoredBy") || "NA"}</Col>
          </Row>
        ) : null}
        {get(data, "sponsoringDepartment") ? (
          <Row>
            <Col lg={5}>
              {get(data, "sponsoredBy") == "Arunachal Pradesh"
                ? "Beneficiary Department"
                : "Sponsoring Department"}
            </Col>
            <Col lg={7}>{get(data, "sponsoringDepartment.name") || "NA"}</Col>
          </Row>
        ) : null}
        {/* {get(data, "sponsoringDepartment") ? (
          <Row
            style={{
              display:
                get(data, "sponsoredBy") == "Arunachal Pradesh" ? "none" : null
            }}
          >
            <Col lg={5}>
              {projectFormLabel(
                get(data, "sponsoredByid"),
                "department",
                "Sponsoring Department"
              )}
            </Col>
            <Col lg={7}>{get(data, "sponsoringDepartment.name") || "NA"}</Col>
          </Row>
        ) : null} */}
        {get(data, "division") ? (
          <Row>
            <Col lg={5}>Division/Zone</Col>
            <Col lg={7}>{get(data, "division.name") || "NA"}</Col>
          </Row>
        ) : null}
        {isValidArray(
          get(data, "districtName") && (
            <Row>
              <Col lg={5}>District/Department</Col>
              <Col lg={7}>
                {get(data, "districtName").map((district, index) => (
                  <span>
                    {district.name}
                    {district.parentName ? ` (${district.parentName})` : ""}
                    {index < get(data, "districtName").length - 1
                      ? ", "
                      : ""}{" "}
                  </span>
                ))}
              </Col>
            </Row>
          )
        ) || null}

        {data && data.locations && data.locations.length ? (
          <Row>
            <Col lg={5}>Location</Col>
            <Col lg={7} className="add-scroll">
              <ul className="pragati-list">
                {(data &&
                  data.locations.map((list, index) => (
                    <li key={`list-key-${index}`} className="location-list">
                      <p>
                        State : {list.state}{" "}
                        {(list.districtIdName &&
                          list.districtIdName.length &&
                          `| ${
                            list.districtIdName.length === 1
                              ? `District`
                              : "Districts"
                          }:
                            ${list.districtIdName.map(
                              item => " " + item.name
                            )}`) ||
                          null}{" "}
                        {(list.circleIdName &&
                          list.circleIdName.length &&
                          `| ${
                            list.circleIdName.length === 1
                              ? `Circle`
                              : "Circles"
                          }:
                            ${list.circleIdName.map(
                              item => " " + item.name
                            )}`) ||
                          null}
                        {/* {(list.distance &&
                          `| Distance(Km): ${list.distance}`) ||
                          null}{" "}
                        {(list.cost && `| Cost(Cr): ${list.cost}`) || null} */}
                      </p>
                    </li>
                  ))) ||
                  "NA"}
              </ul>
            </Col>
          </Row>
        ) : null}
        {get(data, "implMode") ? (
          <Row>
            <Col lg={5}>Implementation Mode</Col>
            <Col lg={7}>{get(data, "implMode", "NA")}</Col>
          </Row>
        ) : null}
        {get(data, "centralCost") || get(data, "centralCost") == 0 ? (
          <Row>
            <Col lg={5}>Project Cost Share</Col>
            <Col lg={7}>
              <ul className="pragati-list">
                <li>Central Share: {`₹ ${get(data, "centralCost")} Cr.`}</li>
                <li>State Share: {`₹ ${get(data, "stateCost")} Cr.`}</li>
              </ul>
            </Col>
          </Row>
        ) : null}
        {get(data, "fundReleaseCost") || get(data, "fundReleaseCost") == 0 ? (
          <Row>
            <Col lg={5}>Funds released to the Executing Agency</Col>
            <Col lg={7}>{`₹ ${get(data, "fundReleaseCost")} Cr.`}</Col>
          </Row>
        ) : null}
        {get(data, "sector") ? (
          <Row>
            <Col lg={5}>Sector</Col>
            <Col lg={7}>{get(data, "sector")}</Col>
          </Row>
        ) : null}
        {get(data, "executingAgency") ? (
          <Row>
            <Col lg={5}>Executing Agency Name</Col>
            <Col lg={7}>{get(data, "executingAgency")}</Col>
          </Row>
        ) : null}
        {get(data, "subSector") ? (
          <Row>
            <Col lg={5}>Sub Sector</Col>
            <Col lg={7}>{get(data, "subSector")}</Col>
          </Row>
        ) : null}
        {get(data, "schemeForAr") ? (
          <Row>
            <Col lg={5}>Project Scheme</Col>
            <Col lg={7}>{get(data, "schemeForAr") || "NA"}</Col>
          </Row>
        ) : null}
        {get(data, "scheme") ? (
          <Row
            style={{
              display:
                get(data, "sponsoredBy") == "Arunachal Pradesh" ? "none" : null
            }}
          >
            <Col lg={5}>Scheme</Col>
            <Col lg={7}>{get(data, "scheme") || "NA"}</Col>
          </Row>
        ) : null}
        {isValidArray(get(data, "banks")) ? (
          <Row>
            <Col lg={5}>Bank</Col>
            <Col lg={7}>
              <ul className="pragati-list">
                {(isValidArray(get(data, "banks")) &&
                  get(data, "banks").map((bankList, index) => (
                    <li>{bankList}</li>
                  ))) ||
                  "NA"}
              </ul>
            </Col>
          </Row>
        ) : null}

        {get(data, "finClosureDate") ? (
          <Row>
            <Col lg={5}>Date of Financial Closure Actual</Col>
            <Col lg={7}>
              {(get(data, "finClosureDate") &&
                dateFormat(get(data, "finClosureDate"))) ||
                "NA"}
            </Col>
          </Row>
        ) : null}

        {get(data, "implementationStarted") ? (
          <Row>
            <Col lg={5}>Project Stage </Col>

            <Col lg={7}>
              {get(data, "implementationStarted", "NA")
                .toLowerCase()
                .replace(/_/g, " ")
                .replace(/(?: |\b)(\w)/g, function(key, p1) {
                  return key.toUpperCase();
                })}
            </Col>
          </Row>
        ) : null}
        {(get(data, "projectCompletionDTO") && (
          <Row>
            <Col lg={5}>Project Status</Col>
            <Col lg={7}>
              {get(data, "projectCompletionDTO.status") !== null ? (
                <ul className="pragati-list">
                  <li>
                    {(() => {
                      const status = get(data, "projectCompletionDTO.status");

                      return Project_Stage_Helper(
                        status === "PHYSICALLY COMPLETED/CC UNDER ISSUE" ? (
                          <>Physically Completed/CC Under Issue</>
                        ) : status === "NO IMPLEMENTATION" ? (
                          <>Under Development</>
                        ) : (
                          <>
                            {status
                              .toLowerCase()
                              .replace(/_/g, " ")
                              .replace(/(?: |\b)(\w)/g, function(key, p1) {
                                return key.toUpperCase();
                              })}
                          </>
                        )
                      );
                    })()}
                  </li>
                  <div>
                    {get(data, "projectCompletionDTO.date") ? (
                      <li>
                        {get(data, "projectCompletionDTO.status") ==
                        "PROVISIONALLY COMMISSIONED" ? (
                          <>Provisional Commissioning Date -</>
                        ) : null}{" "}
                        {get(data, "projectCompletionDTO.status") ==
                        "COMMISSIONED" ? (
                          <>Commissioning Date -</>
                        ) : null}{" "}
                        {get(data, "projectCompletionDTO.status") ==
                        "PHYSICALLY COMPLETED/CC UNDER ISSUE" ? (
                          <>Physical Completion Date -</>
                        ) : null}{" "}
                        {get(data, "projectCompletionDTO.status") ==
                        "UNDER CONSTRUCTION" ? (
                          <>Physical Progress As of -</>
                        ) : null}{" "}
                        {dateFormat(get(data, "projectCompletionDTO.date"))}
                      </li>
                    ) : null}
                    {get(data, "projectCompletionDTO.physicalProgressAsOf") ? (
                      <li>
                        Physical Progress As of -{" "}
                        {dateFormat(
                          get(data, "projectCompletionDTO.physicalProgressAsOf")
                        )}
                      </li>
                    ) : null}
                    <div>
                      {iigReferenceId ? (
                        <>
                          <li>
                            Planned Physical Progress -{" "}
                            {plannedPhysicalProgress &&
                              `${plannedPhysicalProgress}%`}
                          </li>
                          Actual Physical Progress -{" "}
                          {actualPhysicalProgress &&
                            `${actualPhysicalProgress}%`}
                        </>
                      ) : (
                        ""
                      )}
                      {actualPhysicalProgress && !iigReferenceId ? (
                        <li>
                          Physical Progress - {`${actualPhysicalProgress}%`}
                        </li>
                      ) : null}
                    </div>
                    <div
                      className={`${
                        iigReferenceId ? "planned-Financial-Progress" : ""
                      }`}
                    >
                      {iigReferenceId ? (
                        <>
                          <li>
                            Planned Financial Progress -{" "}
                            {plannedFinancialProgress &&
                              `${plannedFinancialProgress}%`}
                          </li>
                          Actual Financial Progress -{" "}
                          {actualFinancialProgress &&
                            `${actualFinancialProgress}%`}
                        </>
                      ) : null}
                      {actualFinancialProgress && !iigReferenceId ? (
                        <li>
                          Financial Progress - {`${actualFinancialProgress}%`}
                        </li>
                      ) : null}
                    </div>
                  </div>
                </ul>
              ) : (
                "NA"
              )}
            </Col>
          </Row>
        )) ||
          null}

        {get(data, "projectSanctionDate") ? (
          <Row>
            <Col lg={5}>Sanction Date</Col>
            <Col lg={7}>
              {(get(data, "projectSanctionDate") &&
                dateFormat(get(data, "projectSanctionDate"))) ||
                "NA"}
            </Col>
          </Row>
        ) : null}

        {get(data, "implementationStartDate") ? (
          <Row>
            <Col lg={5}>Implementation Start Date</Col>
            <Col lg={7}>
              {(get(data, "implementationStartDate") &&
                dateFormat(get(data, "implementationStartDate"))) ||
                "NA"}
            </Col>
          </Row>
        ) : null}

        {get(data, "anticipatedDateOfCompletion") ? (
          <Row>
            <Col lg={5}>Original Date of Completion</Col>
            <Col lg={7}>
              {(get(data, "anticipatedDateOfCompletion") &&
                dateFormat(get(data, "anticipatedDateOfCompletion"))) ||
                "NA"}
            </Col>
          </Row>
        ) : null}

        {(data && data.revisedTargetCompletionDate && (
          <Row>
            <Col lg={5}>Revised Target Date of Completion</Col>
            <Col lg={7}>{dateFormat(data.revisedTargetCompletionDate)}</Col>
          </Row>
        )) ||
          null}

        <ProjectDetailsExtension
          data={data}
          sponsoredByid={get(data, "sponsoredByid")}
          fieldName={"population_benefitted"}
        />

        {get(data, "secretaryReviewDates") &&
        get(data, "secretaryReviewDates").length ? (
          <Row
            style={{
              display:
                get(data, "sponsoredByCategory") === "STATE" ? "none" : null
            }}
          >
            <Col lg={5}>Secretary Review Date</Col>
            <Col lg={7}>
              <ul className="pragati-list shift-to-right">
                {(get(data, "secretaryReviewDates") &&
                  get(data, "secretaryReviewDates").length &&
                  get(data, "secretaryReviewDates").map((item, index) => {
                    return (
                      <span>
                        {dateFormat(item)}
                        {!(
                          get(data, "secretaryReviewDates").length - 1 ===
                          index
                        )
                          ? ", "
                          : ""}
                      </span>
                    );
                  })) ||
                  "NA"}
              </ul>
            </Col>
          </Row>
        ) : null}

        {get(data, "implMode") === "PRIVATE" &&
          (isCenterSponsored || iigPayload !== null) &&
          (get(data, "pliDTO.pli") === true ? (
            <Row>
              <Col lg={5}>PLI</Col>
              <Col lg={7}>
                {(get(data, "pliDTO.pli") === true && "Yes") || "No"}
              </Col>
            </Row>
          ) : null)}

        <DisplayByPermission display={get(data, "pragatiDTO")}>
          <Row
            style={{
              display: get(data, "sponsoredBy") == "Bihar" ? "none" : null
            }}
          >
            <Col lg={5}>Pragati Review</Col>
            <Col lg={7}>
              {(get(data, "pragatiDTO.pragatiReview") === true && "Yes") ||
                "No"}
            </Col>
          </Row>
        </DisplayByPermission>
        <DisplayByPermission display={get(data, "pragatiDTO")}>
          {get(data, "pragatiDTO.pragatiReview") === true &&
          get(data, "pragatiDTO.pragatiReviewDates") &&
          get(data, "pragatiDTO.pragatiReviewDates").length ? (
            <Row
              style={{
                display: get(data, "sponsoredBy") == "Bihar" ? "none" : null
              }}
            >
              <Col lg={5}>Pragati Review Dates</Col>
              <Col lg={7}>
                <ul className="pragati-list shift-to-right-list">
                  {(get(data, "pragatiDTO.pragatiReviewDates") &&
                    get(data, "pragatiDTO.pragatiReviewDates").length &&
                    get(data, "pragatiDTO.pragatiReviewDates").map(item => {
                      return <li>{dateFormat(item)}</li>;
                    })) ||
                    "NA"}
                </ul>
              </Col>
            </Row>
          ) : null}
        </DisplayByPermission>
        <DisplayByPermission
          display={
            get(data, "pragatiDTO") &&
            get(data, "pragatiDTO.pragatiPipeline") !== false
          }
        >
          <Row>
            <Col lg={5}>Pragati Pipeline</Col>
            <Col lg={7}>
              {(get(data, "pragatiDTO.pragatiPipeline") === true && "Yes") ||
                "No"}
            </Col>
          </Row>
        </DisplayByPermission>
        <DisplayByPermission display={get(data, "pragatiDTO")}>
          {get(data, "pragatiDTO.pragatiPipeline") === true &&
          get(data, "pragatiDTO.pragatiCycleDate") ? (
            <Row>
              <Col lg={5}>Pragati Cycle Date</Col>
              <Col lg={7}>
                {dateFormat(get(data, "pragatiDTO.pragatiCycleDate")) || "NA"}
              </Col>
            </Row>
          ) : null}
        </DisplayByPermission>
        <DisplayByPermission display={get(data, "nipDTO")}>
          {get(data, "nipDTO.nipReview") === true ? (
            <Row
              style={{
                display:
                  get(data, "sponsoredByCategory") === "STATE" ? "none" : null
              }}
            >
              <Col lg={5}>NIP</Col>
              <Col lg={7}>
                {(get(data, "nipDTO.nipReview") === true && "Yes") || "No"}
              </Col>
            </Row>
          ) : null}
        </DisplayByPermission>
        <DisplayByPermission display={get(data, "nipDTO")}>
          {get(data, "nipDTO.nipReview") === true &&
          get(data, "nipDTO.nipReviewDate") ? (
            <Row>
              <Col lg={5}>NIP Inclusion Date</Col>
              <Col lg={7}>
                {dateFormat(get(data, "nipDTO.nipReviewDate")) || "NA"}
              </Col>
            </Row>
          ) : null}
        </DisplayByPermission>
        <DisplayByPermission display={get(data, "pmFoundationStoneDTO")}>
          {get(data, "pmFoundationStoneDTO.pmFoundationStone") === true ? (
            <Row>
              <Col lg={5}>PM Foundation Stone</Col>
              <Col lg={7}>
                {(get(data, "pmFoundationStoneDTO.pmFoundationStone") ===
                  true &&
                  "Yes") ||
                  "No"}
              </Col>
            </Row>
          ) : null}
        </DisplayByPermission>
        <DisplayByPermission display={get(data, "pmFoundationStoneDTO")}>
          {get(data, "pmFoundationStoneDTO.pmFoundationStone") === true &&
          get(data, "pmFoundationStoneDTO.pmFoundationStoneId") ? (
            <Row>
              <Col lg={5}>PM Foundation Stone ID</Col>
              <Col lg={7} style={{ wordBreak: "break-all" }}>
                {get(data, "pmFoundationStoneDTO.pmFoundationStoneId")
                  ? get(data, "pmFoundationStoneDTO.pmFoundationStoneId")
                  : "NA"}
              </Col>
            </Row>
          ) : null}
        </DisplayByPermission>
        <DisplayByPermission display={get(data, "pmFoundationStoneDTO")}>
          {get(data, "pmFoundationStoneDTO.pmFoundationStone") === true &&
          get(data, "pmFoundationStoneDTO.pmFoundationStoneDate") ? (
            <Row>
              <Col lg={5}>PM Foundation Stone Date</Col>
              <Col lg={7}>
                {dateFormat(
                  get(data, "pmFoundationStoneDTO.pmFoundationStoneDate")
                ) || "NA"}
              </Col>
            </Row>
          ) : null}
        </DisplayByPermission>
        <DisplayByPermission display={get(data, "cmPragatiYatraDTO")}>
          {get(data, "cmPragatiYatraDTO.cmPragatiYatra") === true ? (
            <Row
            // style={{
            //   display:
            //     get(data, "sponsoredByCategory") === "STATE" ? "none" : null
            // }}
            >
              <Col lg={5}>CM PRAGATI Yatra</Col>
              <Col lg={7}>
                {(get(data, "cmPragatiYatraDTO.cmPragatiYatra") === true &&
                  "Yes") ||
                  "No"}
              </Col>
            </Row>
          ) : null}
        </DisplayByPermission>
        <DisplayByPermission display={get(data, "cmPragatiYatraDTO")}>
          {get(data, "cmPragatiYatraDTO.cmPragatiYatra") === true &&
          get(data, "cmPragatiYatraDTO.cmPragatiYatraDate") ? (
            <Row>
              <Col lg={5}>CM PRAGATI Yatra Date</Col>
              <Col lg={7}>
                {dateFormat(
                  get(data, "cmPragatiYatraDTO.cmPragatiYatraDate")
                ) || "NA"}
              </Col>
            </Row>
          ) : null}
        </DisplayByPermission>
        <DisplayByPermission display={get(data, "cmFoundationStoneDTO")}>
          {get(data, "cmFoundationStoneDTO.cmFoundationStone") === true ? (
            <Row
            // style={{
            //   display:
            //     get(data, "sponsoredByCategory") === "STATE" ? "none" : null
            // }}
            >
              <Col lg={5}>CM Foundation Stone</Col>
              <Col lg={7}>
                {(get(data, "cmFoundationStoneDTO.cmFoundationStone") ===
                  true &&
                  "Yes") ||
                  "No"}
              </Col>
            </Row>
          ) : null}
        </DisplayByPermission>
        <DisplayByPermission display={get(data, "cmFoundationStoneDTO")}>
          {get(data, "cmFoundationStoneDTO.cmFoundationStone") === true &&
          get(data, "cmFoundationStoneDTO.cmFoundationStoneDate") ? (
            <Row>
              <Col lg={5}>CM Foundation Stone Date</Col>
              <Col lg={7}>
                {dateFormat(
                  get(data, "cmFoundationStoneDTO.cmFoundationStoneDate")
                ) || "NA"}
              </Col>
            </Row>
          ) : null}
        </DisplayByPermission>
        {(isCenterSponsored || iigPayload !== null) && (
          <>
            <DisplayByPermission display={get(data, "pmGatiShaktiNewDTO")}>
              {get(data, "pmGatiShaktiNewDTO.pmGatiShaktiNew") === true ? (
                <Row>
                  <Col lg={5}>PM Gatishakti</Col>
                  <Col lg={7}>
                    {(get(data, "pmGatiShaktiNewDTO.pmGatiShaktiNew") ===
                      true &&
                      "Yes") ||
                      "No"}
                  </Col>
                </Row>
              ) : null}
            </DisplayByPermission>
            <DisplayByPermission display={get(data, "pmGsHipDTO")}>
              {get(data, "pmGsHipDTO.pmgsHip") === true ? (
                <Row>
                  <Col lg={5}>PM Gatishakti (NPG)</Col>
                  <Col lg={7}>
                    {(get(data, "pmGsHipDTO.pmgsHip") === true && "Yes") ||
                      "No"}
                  </Col>
                </Row>
              ) : null}
            </DisplayByPermission>
            <DisplayByPermission display={get(data, "pmGsHipDTO")}>
              {get(data, "pmGsHipDTO.pmgsHip") === true &&
              get(data, "pmGsHipDTO.pmgsHipDate") ? (
                <Row>
                  <Col lg={5}>PM Gatishakti (NPG) Date</Col>
                  <Col lg={7}>
                    {(get(data, "pmGsHipDTO.pmgsHip") &&
                      dateFormat(get(data, "pmGsHipDTO.pmgsHipDate"))) ||
                      "NA"}
                  </Col>
                </Row>
              ) : null}
            </DisplayByPermission>
            {get(data, "portConnectivityDTO.portConnectivity") ? (
              <Row>
                <Col lg={5}>Port Connectivity</Col>
                <Col lg={7}>
                  {get(data, "portConnectivityDTO.portConnectivity")
                    ? "Yes"
                    : "No"}
                </Col>
              </Row>
            ) : null}
            {get(data, "coalConnectivityDTO.coalConnectivity") ? (
              <Row>
                <Col lg={5}>Coal Evacuation</Col>
                <Col lg={7}>
                  {get(data, "coalConnectivityDTO.coalConnectivity")
                    ? "Yes"
                    : "No"}
                </Col>
              </Row>
            ) : null}
            {get(data, "esamikshaDTO.esamiksha") ? (
              <Row>
                <Col lg={5}>eSamikSha</Col>
                <Col lg={7}>
                  {get(data, "esamikshaDTO.esamiksha") ? "Yes" : "No"}
                </Col>
              </Row>
            ) : null}
            {get(data, "march24DTO.march24") ? (
              <Row>
                <Col lg={5}>March'24</Col>
                <Col lg={7}>
                  {get(data, "march24DTO.march24") ? "Yes" : "No"}
                </Col>
              </Row>
            ) : null}
          </>
        )}
        {get(data, "timeOverRun") && get(data, "timeOverRun") !== null ? (
          <Row>
            <Col lg={5}>
              Time Overrun
              <TooltipComponent
                classes="create_project_tolltip"
                content={
                  "Time OverRun = (Revised Target Date Of Completion-Anticipated Date Of Completion)/(Anticipated Date Of Completion-Implementation Start Date)"
                }
              />
            </Col>
            <Col lg={7}>
              {get(data, "timeOverRun").percentage &&
              get(data, "timeOverRun").percentage < 0
                ? "On Time"
                : `${get(data, "timeOverRun").percentage.toFixed(2)}% (${
                    get(data, "timeOverRun").value
                  }
                  ${get(data, "timeOverRun").value === 1 ? "day" : "days"})` ||
                  "NA"}
            </Col>
          </Row>
        ) : null}
        {get(data, "costOverRun") && get(data, "costOverRun") !== null ? (
          <Row>
            <Col lg={5}>
              Cost Overrun
              <TooltipComponent
                classes="create_project_tolltip"
                content={
                  "Cost OverRun = (Revised Cost-Original Cost)/Original Cost"
                }
              />
            </Col>
            <Col lg={7}>
              {get(data, "costOverRun").percentage &&
              get(data, "costOverRun").percentage < 0
                ? "On Track"
                : `${get(data, "costOverRun").percentage.toFixed(2)}% (${
                    get(data, "costOverRun").value
                  } Cr.)` || "NA"}
            </Col>
          </Row>
        ) : null}

        <ProjectDetailsExtension
          data={data}
          sponsoredByid={get(data, "sponsoredByid")}
          sponsoredByCategory={get(data, "sponsoredByCategory")}
          fieldName={"geo_coordinates"}
          isUserStatePMG={isUserStatePMG}
        />

        {get(data, "mapImageFiles") &&
        isValidArray(get(data, "mapImageFiles")) ? (
          <Row>
            <Col lg={5}>Project map</Col>
            <Col lg={7}>
              <div className="attachment-added success-file">
                {(isValidArray(get(data, "mapImageFiles")) &&
                  get(data, "mapImageFiles", []).map((file, index) => {
                    const extension = file.name.substr(
                      file.name.lastIndexOf(".") + 1,
                      file.name.length
                    );
                    const name = file.name.substr(
                      0,
                      file.name.lastIndexOf(".")
                    );

                    return (
                      <div className="project-download-icons">
                        <div className="download-icons-pdf">{extension}</div>
                        <a
                          role="button"
                          download={get(file, "name", "NA")}
                          href={get(file, "s3Url", "NA")}
                          target={get(file, "name", "NA")}
                        >
                          {name}
                        </a>
                      </div>
                    );
                  })) ||
                  "NA"}
              </div>
            </Col>
          </Row>
        ) : null}
        {get(data, "documents") && isValidArray(get(data, "documents")) ? (
          <Row>
            <Col lg={5}>Supporting Document</Col>
            <Col lg={7}>
              <div className="attachment-added success-file">
                {(isValidArray(get(data, "documents")) &&
                  get(data, "documents", []).map((documentsList, index) => {
                    const extension = documentsList.name.substr(
                      documentsList.name.lastIndexOf(".") + 1,
                      documentsList.name.length
                    );
                    const name = documentsList.name.substr(
                      0,
                      documentsList.name.lastIndexOf(".")
                    );

                    return (
                      <div className="project-download-icons">
                        <div className="download-icons-pdf">{extension}</div>
                        <a
                          role="button"
                          download={get(documentsList, "name", "NA")}
                          href={get(documentsList, "s3Url", "NA")}
                          target={get(documentsList, "name", "NA")}
                        >
                          {get(documentsList, "title") || name}
                        </a>
                      </div>
                    );
                  })) ||
                  "NA"}
              </div>
            </Col>
          </Row>
        ) : null}
      </Col>
    );
  };

  getProjectDetailsInAccordion = (
    data,
    isProjectDetailsTabActive,
    projectCost,
    iigPayload,
    iigMappingDetails
  ) => {
    const targetDate = get(data, "createdDate");
    const deployedDate = new Date("2026-07-08").getTime();
    return (
      <Col lg={8} className="history-activity project-detail-comments-updates">
        <div className="accordion-content">
          <div className="ah-content-head">
            <h2
              className={`ah-heading project-type-heading ${isProjectDetailsTabActive &&
                "active"}`}
              onClick={() => {
                this.showProjectDetails();
              }}
            >
              Project Details
            </h2>
            <h2
              className={`ah-heading project-type-heading ${!isProjectDetailsTabActive &&
                "active"}`}
              onClick={() => {
                this.showProjectDetailsWithIIG();
              }}
            >
              Project Details Received from{" "}
              {targetDate >= deployedDate ? "CRIP" : "IIG"}
            </h2>
          </div>
          <div
            className={`ah-content-wrapper ${isProjectDetailsTabActive &&
              "active"}`}
          >
            {(isProjectDetailsTabActive &&
              this.getProjectDetailsHTML(data, projectCost, 12)) ||
              null}
          </div>
          <div
            className={`ah-content-wrapper ${!isProjectDetailsTabActive &&
              "active"}`}
          >
            {(!isProjectDetailsTabActive && (
              <Col lg={12} className="details-table">
                {iigPayload && iigPayload.groupId ? (
                  <Row>
                    <Col lg={5}>Sponsoring Ministry</Col>
                    <Col lg={7}>
                      {iigMappingDetails.sponsoringMinistry || "N/A"}
                    </Col>
                  </Row>
                ) : null}
                {iigMappingDetails && iigMappingDetails.sector ? (
                  <Row>
                    <Col lg={5}>Sector</Col>
                    <Col lg={7}>{iigMappingDetails.sector || "N/A"}</Col>
                  </Row>
                ) : null}
                {iigMappingDetails ? (
                  <Row>
                    <Col lg={5}>Subsector</Col>
                    <Col lg={7}>{iigMappingDetails.subSector || "N/A"}</Col>
                  </Row>
                ) : null}
                {iigPayload &&
                iigPayload.locations &&
                iigPayload.locations.length ? (
                  <Row>
                    <Col lg={5}>Location</Col>
                    <Col lg={7} className="add-scroll">
                      <ul className="pragati-list">
                        {(iigPayload &&
                          iigMappingDetails.iigLocations.map(
                            (location, index) => (
                              <li
                                key={`list-key-${index}`}
                                className="location-list"
                              >
                                <p>
                                  State : {location.state} | District:{" "}
                                  {location.districtList
                                    .filter(district => district)
                                    .join(", ") || "N/A"}
                                </p>
                              </li>
                            )
                          )) ||
                          "N/A"}
                      </ul>
                    </Col>
                  </Row>
                ) : null}
                {iigMappingDetails && iigMappingDetails.implementationMode ? (
                  <Row>
                    <Col lg={5}>Implementation Mode</Col>
                    <Col lg={7}>
                      {iigMappingDetails.implementationMode || "N/A"}
                    </Col>
                  </Row>
                ) : null}
                {iigMappingDetails && iigMappingDetails.projectStage ? (
                  <Row>
                    <Col lg={5}>Project Stage</Col>
                    <Col lg={7}>{iigMappingDetails.projectStage || "N/A"}</Col>
                  </Row>
                ) : null}
                {data && data.iigProjectStatus ? (
                  <Row>
                    <Col lg={5}>
                      {targetDate >= deployedDate ? "CRIP" : "IIG"} Project
                      Status
                    </Col>
                    <Col lg={7}>{data.iigProjectStatus || "N/A"}</Col>
                  </Row>
                ) : null}
                {iigPayload && iigPayload.userMeta ? (
                  <Row>
                    <Col lg={5}>User ID</Col>
                    <Col lg={7}>{iigPayload.userMeta.userID || "N/A"}</Col>
                  </Row>
                ) : null}
                {iigPayload && iigPayload.userMeta ? (
                  <Row>
                    <Col lg={5}>User Name</Col>
                    <Col lg={7}>{iigPayload.userMeta.userName || "N/A"}</Col>
                  </Row>
                ) : null}
                {iigPayload && iigPayload.userMeta ? (
                  <Row>
                    <Col lg={5}>Email</Col>
                    <Col lg={7}>{iigPayload.userMeta.email || "N/A"}</Col>
                  </Row>
                ) : null}
                {iigPayload && iigPayload.userMeta ? (
                  <Row>
                    <Col lg={5}>Phone Number</Col>
                    <Col lg={7}>{iigPayload.userMeta.phone || "N/A"}</Col>
                  </Row>
                ) : null}
                {iigPayload && iigPayload.userMeta ? (
                  <Row>
                    <Col lg={5}>Designation</Col>
                    <Col lg={7}>{iigPayload.userMeta.designation || "N/A"}</Col>
                  </Row>
                ) : null}
                {iigPayload && iigPayload.userMeta ? (
                  <Row>
                    <Col lg={5}>Organization</Col>
                    <Col lg={7}>
                      {iigPayload.userMeta.organization || "N/A"}
                    </Col>
                  </Row>
                ) : null}
              </Col>
            )) ||
              null}
          </div>
        </div>
      </Col>
    );
  };

  getProjectDetailsWithoutAccordion = (data, projectCost, isUserStatePMG) => {
    return this.getProjectDetailsHTML(data, projectCost, 8, isUserStatePMG);
  };

  inputLanguage = event => {
    const { projectData } = this.props;
    let data = get(projectData, "data", null);
    if (window.event.inputType !== "insertFromPaste") {
      if (
        !event.target.value.match(/[\u0900-\u097F]/) ||
        get(data, "sponsoredByCategory") != "STATE"
      ) {
        let hasInputValue = handleLanguage(event);
        this.setState({
          languageError: hasInputValue,
          pasteError: false
        });
      }
    }
  };

  pasteLanguage = () => {
    const { projectData } = this.props;
    let data = get(projectData, "data", null);
    if (
      !this.state.comment.match(/[\u0900-\u097F]/) ||
      get(data, "sponsoredByCategory") != "STATE"
    ) {
      let { filterString, hasBadValue } = handlePaste(this.state.comment);
      if (hasBadValue === true) {
        this.setState({
          pasteError: hasBadValue,
          comment: filterString
        });
      }
    }
  };
  onMouseclick = () => {
    window.addEventListener("keypress", event => {
      this.setState({
        showCommentError: false
      });
    });
  };
  onPaste = () => {
    window.addEventListener("paste", event => {
      this.setState({
        showCommentError: false
      });
    });
  };
  showAddDecisionModal = () => {
    this.setState({
      showAddDecisionModal: true
    });
  };
  closeAddDecisionModal = () => {
    this.setState({
      showAddDecisionModal: false
    });
  };

  costDistribute = () => {
    const data = get(this.props.projectData, "data", {});
    const locations = Array.isArray(data.locations) ? data.locations : [];

    const rawCostData = this.state.costDistributionData;
    const hasCostData =
      rawCostData &&
      typeof rawCostData === "object" &&
      Object.keys(rawCostData).length > 0;

    const result = {};
    const indexes = hasCostData ? Object.keys(rawCostData) : ["0"];

    indexes.forEach(index => {
      const phaseData =
        hasCostData && Array.isArray(rawCostData[index])
          ? rawCostData[index]
          : [];

      const costMap = phaseData.reduce((acc, row) => {
        if (row.stateOrUT) {
          acc[row.stateOrUT] = row;
        }
        return acc;
      }, {});

      const headerRow = phaseData[0] || {};

      const uncoveredHeaderObj =
        headerRow.totalLocationsUncoveredHeader || "Select";
      const connectedHeaderObj =
        headerRow.totalLocationsConnectedHeader || "Select";
      const totalOFC = headerRow.totalOFCPlannedHeader || "Select";
      const OFCLaid = headerRow.totalOFCInstalledHeader || "Select";

      result[index] = locations.map(loc => {
        const existingCost = costMap[loc.state] || {};

        return {
          ...existingCost,

          tableIndex: Number(index),
          stateOrUT: loc.state || existingCost.stateOrUT || "",

          totalOFCInstalled:
            loc.totalOFCInstalled !== undefined &&
            loc.totalOFCInstalled !== null
              ? loc.totalOFCInstalled
              : existingCost.totalOFCInstalled,
          totalOFCPlanned:
            loc.totalOFCPlanned !== undefined && loc.totalOFCPlanned !== null
              ? loc.totalOFCPlanned
              : existingCost.totalOFCPlanned,
          physicalProgressPercentage:
            loc.physicalProgressPercentage ||
            existingCost.physicalProgressPercentage ||
            0,

          totalLocationsUncoveredHeader: uncoveredHeaderObj,
          totalLocationsConnectedHeader: connectedHeaderObj,

          totalLocationsUncovered:
            loc.totalLocationsUncovered !== undefined &&
            loc.totalLocationsUncovered !== null
              ? loc.totalLocationsUncovered
              : existingCost.totalLocationsUncovered,
          totalLocationsConnected:
            loc.totalLocationsConnected !== undefined &&
            loc.totalLocationsConnected !== null
              ? loc.totalLocationsConnected
              : existingCost.totalLocationsConnected,

          totalOFCPlannedHeader: totalOFC,
          totalOFCInstalledHeader: OFCLaid,

          totalProjectCost:
            loc.totalProjectCost !== undefined && loc.totalProjectCost !== null
              ? loc.totalProjectCost
              : existingCost.totalProjectCost,
          implementationAgency:
            loc.implementationAgency || existingCost.implementationAgency || ""
        };
      });
    });
    return result;
  };

  handleUpdateProject = () => {
    const { iigProjectReferenceId } = this.state;
    const accessToken = getLocalstorage("token");

    const url =
      `${iigBaseUrl}/pmg/project` +
      `?projectId=${encodeURIComponent(iigProjectReferenceId)}` +
      `&action=update` +
      `#t=${encodeURIComponent(accessToken)}`;
    console.log("url created", url);

    window.open(url, "_blank", "noopener,noreferrer");
  };

  render() {
    const {
      onChangeComment,
      onChangeNewComment,
      onSubmitComment,
      onSubmitNewComment,
      onToggleCommentSection,
      onToggleNewComment,
      handleTerminatedDate,
      onHandleChecked
    } = this;
    const {
      location: { search },
      projectData,
      loading,
      handleOnClick,
      permission,
      isProjectAwardedByState,
      projectTimelineData,
      projectTimelineStatus,
      getMilestoneGanttChartData,
      projectDecisionData,
      projectAddDecisionStatus,
      previewData
    } = this.props;
    // console.log("previewData", isProjectAwardedByState);
    const { issueListDTO, isIssueLoaded, isOpen, pmgAccordion } = this.state;
    const dataObj = projectData.data;
    const isProjectAwardedByStateCat = dataObj && dataObj.sponsoredByCategory;
    const dataloc = get(projectData, "data", {});
    const dataLocations = dataloc.locations;

    const totalPhases =
      Math.max(...Object.keys(this.state.costDistributionData).map(Number), 0) +
      1;
    const phases =
      this.state.phaseIndex && this.state.phaseIndex.length == 0
        ? Array.from({ length: totalPhases }, (_, i) => i)
        : this.state.phaseIndex;

    const issueCount =
      issueListDTO !== null &&
      issueListDTO !== undefined &&
      issueListDTO.total !== 0;

    let issueStatus = false;
    if (issueCount) {
      issueListDTO.listDTO.map(issue => {
        if (
          issue.status == "Pending with SM" ||
          // issue.status == "Pending with State PMG"
          issue.status == "Pending with SPMG/SD"
        ) {
          issueStatus = true;
        }
      });
    }

    const rows = this.state.costDistributionData[this.state.activeIndex] || [];
    const hasValidData = rows.some(
      row =>
        row.totalLocationsConnected !== null &&
        row.totalLocationsConnected !== undefined
    );

    const { getCommentAndUpdates } = this;

    // get project id
    const { projectId } = queryString.parse(search);
    // redirect page
    if (!projectId) {
      return <Redirect to={PATHS.PROJECT_LIST} />;
    }
    const {
      show,
      type,
      error,
      status,
      comment,
      showAlert,
      addedComment,
      addedNewComment,
      isApiLoading,
      ProjectDetails,
      ProjectActions,
      isNoteApiLoading,
      isCommentApiLoading,
      commentUpdatesData,
      toggleCommentWindow,
      showNewCommentModal,
      isCommentAndUpdatesLoading,
      toggleAttachementDisplay,
      files,
      mapImageFiles,
      showTimeline,
      showMilestone,
      showEditMilestone,
      showBtn,
      terminatedDate,
      iigProjectReferenceId,
      milestoneData,
      isProjectDetailsTabActive,
      pasteError,
      languageError,
      showCommentError,
      showAddDecisionModal,
      getProjectDetails,
      projectNotemodifyDate,
      projectNoteuserId,
      projectNoteuserName,
      EditLoading
    } = this.state;
    //console.log("EditLoading", EditLoading, "show", show);
    let data = get(projectData, "data", null);
    const projectCost = formatNumber(
      get(data, "revisedCost", 0) || get(data, "cost", "0")
    );
    const tasks = getTasksFromBucketData(this.state.milestoneData);

    let representsDelay = false;
    if (tasks !== null) {
      const delayedTask = tasks.find(task => task.delayInDays > 0);
      if (delayedTask) {
        representsDelay = true;
      }
    }
    if (loading === "SUCCESS" && getProjectDetails) {
      const isIIGDraft = getProjectDetails.status === "CRIP_DRAFT";
      if (isIIGDraft) {
        return (
          <Redirect
            to={{
              pathname: PATHS.IIG_PROJECT_DETAIL,
              search: `?projectId=${projectData.data.id}`
            }}
          />
        );
      }
    }
    const iigPayload = get(data, "iigPayload", null);
    const userInfo = getLocalstorage("user");
    const isUserPP = userInfo.groupCategory === "PP";
    const isUserStatePMG = userInfo.groupCategory === "STATE_PMG";
    const isEdit = get(data, "edit", false);
    const isCenterSponsored = get(data, "sponsoredByCategory") === "CENTRAL";
    const isUserPMG = userInfo.groupCategory === "PMG";
    const isNotUserPMG = userInfo.groupCategory !== "PMG";
    const isVerified = get(data, "status") === "VERIFIED";
    const isUnderVerification = get(data, "status") === "UNDER_VERIFICATION";
    const iigMappingDetails = get(data, "iigMappingdetails", null);
    const accessToken = getLocalstorage("token");
    return (
      <React.Fragment>
        {this.state.showCommentError === true &&
          (this.onMouseclick() || this.onPaste())}
        {showAddDecisionModal ? (
          <ProjectAddDecisionModal
            isUserPMG={isUserPMG}
            show={showAddDecisionModal}
            onHide={this.closeAddDecisionModal}
            projectData={data}
            projectAddedDecisionData={projectDecisionData}
            projectAddDecisionStatus={projectAddDecisionStatus}
          />
        ) : (
          <></>
        )}
        <Container>
          {/* Reason For Delay Popup */}
          <Modal
            show={this.state.showPopup}
            onHide={this.onModalHide}
            className="milestone-modal"
          >
            <Modal.Header closeButton>
              <Modal.Title>
                Reason for delay of {this.state.selectedMilestone}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="confirm">
                <textarea
                  value={this.state.reason}
                  disabled
                  placeholder="Reason..."
                />
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                style={{ visibility: "hidden" }}
                className={"add-reason-btn"}
              >
                ADD
              </Button>
            </Modal.Footer>
          </Modal>
          <LoaderPage
            loading={
              isApiLoading === STATUS.LOADING ||
              loading === STATUS.LOADING ||
              projectTimelineStatus === STATUS.LOADING ||
              this.state.projectNotemodalClose
            }
          />
          {toggleAttachementDisplay ? (
            <UploadAttachmentsWithTitleComponent
              displayModal={toggleAttachementDisplay}
              onCloseModal={this.onToggleAttachment}
              fileFormats={DOCUMENT_FORMATS}
              onSubmit={this.onSuccessUploadOfAttachments}
            />
          ) : null}
          {isIssueLoaded && (
            <ConfirmationComponent
              show={showAlert}
              isLoading={loading}
              content={
                <>
                  {status === "ON_HOLD" ? (
                    <>
                      <p>
                        Taking this action will also change the issue status of
                        the project to 'On Hold'.
                      </p>{" "}
                      <p>Do you want to take this action?</p>
                    </>
                  ) : status === "VERIFIED" && issueStatus && issueCount ? (
                    <>
                      {isProjectAwardedByState ? (
                        <div className="issue-text-alignment">
                          <p>Taking this action will verify the Project</p>
                          <p>
                            Click the checkbox below if you also wish to verify
                            the issue(s). You can also verify the issues later.
                          </p>
                        </div>
                      ) : (
                        // <div className="issue-text-alignment">
                        //   <p>Taking this action will verify the Project</p>
                        //   <p>
                        //     Click the checkbox below if you also wish to verify
                        //     the issue(s). You can also verify the issues later.
                        //   </p>
                        // </div>
                        <div className="issue-text-alignment">
                          <p>Taking this action will verify the Project</p>
                          <p>
                            <b>Note: </b>Issue(s) under the Project must be
                            verified separately
                          </p>
                        </div>
                      )}{" "}
                      {isProjectAwardedByState && (
                        <>
                          <div>
                            <ConfirmationCheckbox
                              onHandleChecked={onHandleChecked}
                            />
                          </div>
                          <p className="checkbox-text-alignment">
                            Verify Issue(s)
                          </p>
                        </>
                      )}
                    </>
                  ) : status === "REJECTED" ? (
                    <>
                      <p>
                        Taking this action will also change the issue status of
                        the project to 'Rejected'.
                      </p>{" "}
                      <p>Do you want to take this action?</p>
                    </>
                  ) : status === "TERMINATED" ? (
                    <>
                      <p>
                        Taking this action will also change the issue status of
                        the project to 'Terminated'.
                      </p>{" "}
                      <p>Do you want to take this action?</p>
                    </>
                  ) : status === "FORECLOSED" ? (
                    <>
                      <p>
                        Taking this action will also change the issue status of
                        the project to 'Foreclosed'.
                      </p>{" "}
                      <p>Do you want to take this action?</p>
                    </>
                  ) : status === "REOPEN" ? (
                    <>
                      <p>
                        Taking this action will also revert the issue status of
                        the project.
                      </p>{" "}
                      <p>Do you want to take this action?</p>
                    </>
                  ) : (
                    ""
                  )}
                </>
              }
              modalClass={
                status === "VERIFIED" && issueCount && issueStatus
                  ? "verify-modal"
                  : "confirmation-modal"
              }
              saveHandler={this.onHandleSend}
              closeHandler={this.validateError}
            />
          )}
          <div className="project-overview-wrapper">
            <ProjectOverview
              data={data}
              displayOnDetailPage={true}
              onToggleCommentSection={onToggleCommentSection}
              toggleProjectDetails={this.toggleProjectDetails}
              projectDetails={ProjectDetails}
              projectData={projectData}
            />

            {EditLoading ? (
              <LoaderPage loading={EditLoading} />
            ) : (isUserPMG || iigProjectReferenceId === null) &&
              show &&
              previewData ? (
              <EditProject
                show={show}
                isEdit={true}
                handleClose={this.handleClose}
                onProjectEdit={this.onProjectEdit}
                data={data}
                iigProjectReferenceId={iigProjectReferenceId}
                editData={previewData}
              />
            ) : (
              <></>
            )}

            {/* {(isUserPMG || iigProjectReferenceId === null) && show && (
              <EditProject
                show={show}
                handleClose={this.handleClose}
                onProjectEdit={this.onProjectEdit}
                data={data}
                iigProjectReferenceId={iigProjectReferenceId}
              />
            )} */}

            {iigProjectReferenceId !== null && !isUserPMG && (
              <ModalIIGUpdateProjectDisabled
                show={show}
                handleClose={this.handleClose}
                iigProjectReferenceId={iigProjectReferenceId}
              />
            )}
            <ProjectDetailsSideBar
              projectCost={projectCost}
              data={data}
              handleClose={this.handleShow}
              toggleProjectDetails={this.toggleProjectDetails}
              ProjectDetails={ProjectDetails}
              onToggleCommentSection={onToggleCommentSection}
            />
          </div>
          <div className="project-details-wrapper">
            <div className="project-details">
              {ProjectDetails ? (
                <Row>
                  {iigPayload && isUserPMG
                    ? this.getProjectDetailsInAccordion(
                        data,
                        isProjectDetailsTabActive,
                        projectCost,
                        iigPayload,
                        iigMappingDetails
                      )
                    : this.getProjectDetailsWithoutAccordion(
                        data,
                        projectCost,
                        isUserStatePMG
                      )}
                  <Col
                    lg={3}
                    className="history-activity project-detail-comments-updates"
                  >
                    <div className="accordion-content">
                      <div className="ah-content-head">
                        <h2
                          className={`ah-heading ${type === "comment" &&
                            "active"}`}
                          onClick={() => {
                            getCommentAndUpdates("comment", projectId);
                          }}
                        >
                          Comments
                        </h2>
                        <h2
                          className={`ah-heading ${type === "updates" &&
                            "active"}`}
                          onClick={() => {
                            getCommentAndUpdates("updates", projectId);
                          }}
                        >
                          Updates
                        </h2>
                      </div>
                      <div
                        className={`ah-content-wrapper ${type === "comment" &&
                          "active"}`}
                      >
                        {(type === "comment" && (
                          <Comment
                            isLoading={isCommentAndUpdatesLoading}
                            data={[commentUpdatesData]}
                            // MarginTop={true}
                            template={value => (
                              <>
                                <h4>
                                  Project{" "}
                                  <span className="issue-id">#{projectId}</span>
                                </h4>
                              </>
                            )}
                          />
                        )) ||
                          null}
                      </div>
                      <div
                        className={`ah-content-wrapper ${type === "updates" &&
                          "active"}`}
                      >
                        {(type === "updates" && (
                          <History
                            isLoading={isCommentAndUpdatesLoading}
                            data={[commentUpdatesData]}
                            MarginTop={true}
                            template={value => (
                              <>
                                <h4>
                                  Project{" "}
                                  <span className="issue-id">#{projectId}</span>
                                </h4>
                              </>
                            )}
                            times={4}
                          />
                        )) ||
                          null}
                      </div>
                    </div>
                  </Col>
                </Row>
              ) : null}
              {ProjectActions ? (
                <div className="project-actions">
                  <div
                    // style={{
                    //   background: "#F5F5F5",
                    //   border: "1px solid #ced7f4",
                    //   height: "35px"
                    // }}
                    className="forward-to-team-main-div"
                  >
                    <h3
                      className="heading"
                      style={{
                        paddingTop: "10px",
                        //paddingLeft: "18px",
                        color: "#525252"
                      }}
                    >
                      Action on Project
                    </h3>
                    <div
                      //className="btn-icon remove-issue"
                      className="delete-padding"
                      title="Delete"
                      onClick={this.toggleProjectActions}
                      // style={{
                      //   marginLeft: "0px",
                      //   position: "relative",
                      //   //left: "97%",
                      //   bottom: "25px",
                      //   float: "right",
                      //   marginRight: "20px"
                      // }}
                    >
                      <Image src={Forma} alt="Delet Icon" />
                    </div>
                  </div>
                  <Form
                    className={`forward-to-team-form  ${
                      languageError === true ||
                      (pasteError === true && comment !== "")
                        ? "language-error-border-alert"
                        : ""
                    }`}
                  >
                    <div className="forward-to-team-form-content">
                      <Form.Group
                        className={
                          "field-select field-to" +
                          (status === "TERMINATED" ? " terminated-action" : "")
                        }
                      >
                        <Form.Label>Select Action</Form.Label>
                        {/* <CustomDropdown
                          options={[
                            { value: "", label: "Select Status" },
                            ...get(data, "projectActionList", []).map(function(
                              key
                            ) {
                              return {
                                value: key,
                                label: key.replace(/_/g, " ")
                              };
                            })
                          ]}
                          value={status}
                          onChange={this.handleChange}
                          width={"100%"}
                          height={"43px"}
                          className={"issue-action"}
                          page={"issue-action"}
                          menuClassName={"createIssueMenu"}
                          marginRight={"10px"}
                        /> */}
                        <Field
                          as="select"
                          key="status"
                          keyName="status"
                          value={status}
                          className={
                            status === "TERMINATED" ? "terminated-status" : ""
                          }
                          onChange={this.handleChange}
                          onBlur={this.onBlur}
                        >
                          <option value="">-- Select --</option>
                          {get(data, "projectActionList", []).map(key => {
                            let first = key.toString().replace(/[_]/, " ");
                            return (
                              <option value={key} key={key}>
                                {first}
                              </option>
                            );
                          })}
                        </Field>
                        {status === "TERMINATED" ? (
                          <React.Fragment>
                            <Form.Label className="terminated-label hide-mobile">
                              Termination Date
                            </Form.Label>
                            <DatePicker
                              isClearable={terminatedDate}
                              value={terminatedDate}
                              selected={terminatedDate}
                              className="terminated-date hide-mobile"
                              onChange={value => {
                                handleTerminatedDate(value);
                              }}
                            />
                          </React.Fragment>
                        ) : null}
                      </Form.Group>
                      {status === "TERMINATED" ? (
                        <Form.Group className="terminated-date-wrap hide-desktop">
                          <Form.Label className="terminated-label">
                            Termination Date
                          </Form.Label>
                          <DatePicker
                            isClearable={terminatedDate}
                            value={terminatedDate}
                            selected={terminatedDate}
                            className="terminated-date"
                            onChange={value => {
                              handleTerminatedDate(value);
                            }}
                          />
                        </Form.Group>
                      ) : null}
                      <Form.Group
                        className={
                          files.length !== 0 ? "text-area" : "text-area1"
                        }
                      >
                        <Field
                          as="textarea"
                          rows="4"
                          placeholder=" Add Comment"
                          key="comment"
                          keyName="comment"
                          value={comment}
                          onInput={this.inputLanguage}
                          onChange={this.handleChange}
                          onBlur={this.onBlur}
                        />
                        {this.state.comment !== null &&
                          this.state.comment !== undefined &&
                          this.state.comment.length === 0 && (
                            <span
                              className="required"
                              style={{
                                position: "absolute",
                                left: "147px",
                                paddingTop: "6px"
                              }}
                            >
                              *
                            </span>
                          )}
                      </Form.Group>
                      {files.length !== 0 ? (
                        <hr style={{ marginTop: "8px", marginBottom: "0px" }} />
                      ) : null}
                      <Form.Group className="field-attachment">
                        <DisplayAttachments
                          filesArr={files}
                          onRemoveFile={this.onRemoveFile}
                          addAttchementRequired={false}
                          classes="attachments"
                        />
                      </Form.Group>
                      <Form.Control.Feedback type="invalid">
                        {languageError === true ||
                        (pasteError === true && comment !== "")
                          ? ""
                          : get(error, "comment.message")}
                      </Form.Control.Feedback>
                    </div>
                    <div className="forward-to-team-footer">
                      <div className="forward-to-team-buttons">
                        <div
                          className="add-attachment"
                          onClick={this.onToggleAttachment}
                        >
                          <div
                            className="add-attachment-button"
                            style={{
                              position: "relative",
                              left: "1px",
                              top: "3px"
                            }}
                          >
                            <Image src={IconPin} alt="Attachment Icon" />
                            Add Attachment
                          </div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            position: "relative",
                            paddingBottom: "10px",
                            paddingTop: "10px"
                          }}
                        >
                          <Button
                            className="btn-orange no-padding"
                            onClick={this.validateError}
                            //style={{ position: "relative", left: "78%" }}
                          >
                            SUBMIT
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Form>
                  {(get(error, "comment.error") ||
                    get(error, "status.error")) &&
                  showCommentError === true ? (
                    <div className="error">Mandatory fields are missing</div>
                  ) : null}
                  {languageError === true ||
                  (pasteError === true && comment !== "") ? (
                    <div className="warning">
                      <Image src={CircleWithExclamation} />
                      Only English language is supported.
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              ) : null}
              <p className="d-none">
                {"Action List Valid: " +
                  isValidArray(get(data, "projectActionList"))}
              </p>
              <p className="d-none">
                {"isCenterSponsored: " + isCenterSponsored}
              </p>
              <p className="d-none">{"isVerified: " + isVerified}</p>
              <p className="d-none">{"isNotUserPMG: " + isNotUserPMG}</p>
              <p className="d-none">
                {"isUnderVerification: " + isUnderVerification}
              </p>
              {!ProjectActions ? (
                <ButtonToolbar className="button-container button-group details-btn-grp">
                  {(isValidArray(get(data, "projectActionList")) &&
                    (isUnderVerification ||
                      !(isCenterSponsored && isNotUserPMG && isVerified)) && (
                      <DisplayByPermission
                        display={!get(permission, "canViewOnlyProject")}
                      >
                        <Button
                          className="btn-orange no-padding project-action-button"
                          onClick={this.toggleProjectActions}
                        >
                          Actions
                        </Button>
                      </DisplayByPermission>
                    )) ||
                    null}
                  <DisplayByPermission
                    display={
                      get(data, "addMoreIssue") &&
                      !get(permission, "canViewOnlyIssues") &&
                      get(data, "allowAddIssue")
                    }
                  >
                    <Button
                      className="btn-orange no-padding button-more-issue"
                      onClick={handleOnClick}
                    >
                      + Add Issue
                    </Button>
                  </DisplayByPermission>
                  <DisplayByPermission
                    display={
                      get(permission, "updateProjectStatus") &&
                      get(data, "edit") &&
                      !get(permission, "canViewOnlyProject")
                    }
                  >
                    {iigProjectReferenceId && isUserPMG && (
                      <Button
                        data-test="update-project-details"
                        className="btn-blue no-padding"
                        onClick={this.handleUpdateShow}
                      >
                        Update Project Detail
                      </Button>
                    )}

                    {!iigProjectReferenceId && (
                      <Button
                        data-test="update-project-details"
                        className="btn-blue no-padding"
                        onClick={this.handleUpdateShow}
                      >
                        Update Project Detail
                      </Button>
                    )}
                  </DisplayByPermission>
                  {iigProjectReferenceId &&
                    !this.state.isViewOnly &&
                    (isUserPMG ? (
                      // <a
                      //   // href={
                      //   //   iigBaseUrl +
                      //   //   IIG_PATHS.IIG_PROJECT_UPDATE +
                      //   //   "?iigProject=" +
                      //   //   iigProjectReferenceId
                      //   // }
                      //   href={
                      //     iigBaseUrl +
                      //     "/pmg/project" +
                      //     "?projectId=" +
                      //     iigProjectReferenceId +
                      //     "&action=update" +
                      //     "#t=" +
                      //     accessToken
                      //   }
                      //   target="_blank"
                      //   rel="noreferrer"
                      // >
                      //   <Button className="btn-small download-btn btn-green">
                      //     UPDATE PROJECT
                      //   </Button>
                      // </a>
                      <Button
                        className="btn-small download-btn btn-green"
                        onClick={this.handleUpdateProject}
                      >
                        UPDATE PROJECT
                      </Button>
                    ) : (
                      isEdit && (
                        // <a
                        //   // href={
                        //   //   iigBaseUrl +
                        //   //   IIG_PATHS.IIG_PROJECT_UPDATE +
                        //   //   "?iigProject=" +
                        //   //   iigProjectReferenceId
                        //   // }
                        //   href={
                        //     iigBaseUrl +
                        //     "/pmg/project" +
                        //     "?projectId=" +
                        //     iigProjectReferenceId +
                        //     "&action=update" +
                        //     "#t=" +
                        //     accessToken
                        //   }
                        //   target="_blank"
                        //   rel="noreferrer"
                        // >
                        //   <Button className="btn-small download-btn btn-green">
                        //     UPDATE PROJECT
                        //   </Button>
                        // </a>
                        <Button
                          className="btn-small download-btn btn-green"
                          onClick={this.handleUpdateProject}
                        >
                          UPDATE PROJECT
                        </Button>
                      )
                    ))}
                  <Button
                    className="btn-add-decision no-padding"
                    onClick={this.showAddDecisionModal}
                  >
                    MEETING DECISIONS
                    {projectDecisionData == undefined ||
                    projectDecisionData.data.length == 0 ? (
                      <>&nbsp;{"(0)"}</>
                    ) : (
                      <>&nbsp;({projectDecisionData.data.length})</>
                    )}
                  </Button>
                  <DisplayByPermission
                    display={
                      get(permission, "updateProjectStatus") &&
                      !get(data, "edit") &&
                      get(data, "status") === "ON_HOLD" &&
                      !get(permission, "canViewOnlyProject")
                    }
                  >
                    <Button
                      className="btn-blue no-padding disabled-btn"
                      disabled={true}
                    >
                      Edit project detail
                    </Button>
                  </DisplayByPermission>

                  <Button
                    onClick={onToggleNewComment}
                    className="btn-orange-invert btn-small download-btn"
                  >
                    COMMENT
                  </Button>
                  {get(data, "allowToViewNote") ? (
                    <>
                      {this.state.projectNotemodalClose ? null : (
                        <NoteComponent
                          title="Project Note"
                          isLoading={isNoteApiLoading}
                          value={addedComment}
                          message={addedComment}
                          onChange={onChangeComment}
                          show={toggleCommentWindow}
                          onSubmit={onSubmitComment}
                          onClose={onToggleCommentSection}
                          hideProgressbar={true}
                          projectNotemodifyDate={projectNotemodifyDate}
                          projectNoteuserId={projectNoteuserId}
                          projectNoteuserName={projectNoteuserName}
                        />
                      )}
                    </>
                  ) : null}
                  <CommentComponent
                    title="Add Comment"
                    isLoading={isCommentApiLoading}
                    value={addedNewComment}
                    onChange={onChangeNewComment}
                    show={showNewCommentModal}
                    onSubmit={onSubmitNewComment}
                    onClose={onToggleNewComment}
                  />
                </ButtonToolbar>
              ) : null}
            </div>
            {/* <div className="project-cost">
              <div className="cost-heading">Project Cost</div>
              <div className="cost">
                {parseFloat(projectCost) !== 0 ? `₹ ${projectCost} Cr.` : "N/A"}
              </div>
            </div> */}
          </div>
          {projectTimelineData && projectTimelineData.length && showTimeline ? (
            <div className="project-timeline-wrapper hidden-mobile">
              <div
                className="timeline-scroll"
                id={"timeline-scroll"}
                ref={this.myTimelineRef}
              >
                <ProjectTimeline
                  projectTimelineData={projectTimelineData}
                  // isProjectAwardedByState={isProjectAwardedByState}
                  isProjectAwardedByState={isProjectAwardedByStateCat}
                />
              </div>
              <span
                className="hide-timeline-btn"
                onClick={() => this.setState({ showTimeline: false })}
              >
                HIDE
              </span>
              {showBtn ? (
                <img
                  src={leftArrow}
                  id="slideLeft"
                  ref={this.slideLeftRef}
                  alt={"Left"}
                />
              ) : null}
              {showBtn ? (
                <img
                  src={rightArrow}
                  id="slideRight"
                  ref={this.slideRightRef}
                  alt={"Right"}
                />
              ) : null}
            </div>
          ) : null}
          {!showTimeline ? (
            <div className="project-no-timeline-wrapper hidden-mobile">
              Project Timeline
              <span
                className="show-timeline-btn"
                onClick={() => {
                  this.setState({ showTimeline: true });
                  this.shouldShowMoveBtn();
                }}
              >
                SHOW
              </span>
            </div>
          ) : null}

          {!showMilestone ? (
            <div className="project-no-timeline-wrapper hidden-mobile">
              <div>
                Milestones Overview{" "}
                {get(data, "projectMilestoneStatus") === "DRAFT"
                  ? "(Draft)"
                  : ""}
              </div>
              <span
                className="show-timeline-btn"
                onClick={() => {
                  this.setState({ showMilestone: true });
                }}
              >
                SHOW
              </span>
            </div>
          ) : null}
          {showMilestone ? (
            showEditMilestone ? (
              <div className="project-timeline-wrapper milestone-detail-wrapper update-milestone-box hidden-mobile update-milestone-section">
                <CreateProjectForm
                  openMilestoneEdit={true}
                  isEdit={true}
                  sponsoredByCategory={get(data, "sponsoredByCategory")}
                  projectId={projectId}
                  _sectorId={get(this.state.editProjectData, "sector.id")}
                  _cost={
                    get(this.state.editProjectData, "revisedCost") == null
                      ? get(this.state.editProjectData, "cost")
                      : get(this.state.editProjectData, "revisedCost")
                  }
                  _implementationMode={get(
                    this.state.editProjectData,
                    "implMode"
                  )}
                  displayCabinetMilestoneButton={
                    get(data, "sponsoredByCategory") === "CENTRAL" &&
                    (() => {
                      const cabinet = setDraftDataForMilestone(
                        get(data, "bucketDataDTOList", [])
                          .filter(
                            item =>
                              item.bucket &&
                              item.bucket.name === "Cabinet Milestone"
                          )
                          .slice(-1)
                      );

                      return (
                        cabinet.length > 0 && cabinet[0].disabled === false
                      );
                    })()
                  }
                  _subSectorId={get(data, "subSectorId")}
                  projectMilestoneStatus={get(data, "projectMilestoneStatus")}
                  initialApiCall={this.initialApiCall}
                  onShowDetailsClick={() =>
                    this.setState({ showEditMilestone: false })
                  }
                  onHideUpdate={() => this.setState({ showMilestone: false })}
                  bucketMilestoneCOS={setDraftDataForMilestone(
                    get(data, "bucketDataDTOList", [])
                  )}
                  editMilestoneOriginalDate={get(
                    data,
                    "editMilestoneOriginalDate"
                  )}
                  projectPPList={get(data, "projectPPList", [])}
                  iigProjectReferenceId={iigProjectReferenceId}
                  costDistributionData={this.costDistribute()}
                  groupId={get(data, "sponsoredByid")}
                  locations={
                    window.location.pathname == "/detail-project"
                      ? dataLocations
                      : ""
                  }
                />
              </div>
            ) : (
              <div className="project-timeline-wrapper milestone-detail-wrapper hidden-mobile">
                <div className="milestone-header">
                  <h5>
                    Project Milestones{" "}
                    {get(data, "projectMilestoneStatus") === "DRAFT"
                      ? "(Draft)"
                      : ""}
                  </h5>
                  <div className="milestone-header-right">
                    {get(data, "milestoneLastUpdatedOn") &&
                    get(data, "milestoneLastUpdatedBy.name") ? (
                      <div className="last-updated-block">
                        Last updated by{" "}
                        <RedirectUser
                          title={get(data, "milestoneLastUpdatedBy.name", null)}
                          id={get(data, "milestoneLastUpdatedBy.id", null)}
                          isMilestonePPDetail={true}
                        />{" "}
                        on{" "}
                        <b>
                          {dateFormat(get(data, "milestoneLastUpdatedOn", ""))}
                        </b>{" "}
                        at{" "}
                        <b>
                          {moment(
                            get(data, "milestoneLastUpdatedOn", "")
                          ).format("LT")}
                        </b>
                      </div>
                    ) : null}
                    <div
                      className={`download-excel-component ${
                        get(permission, "canViewOnlyProject")
                          ? "download-excel"
                          : ""
                      }`}
                    >
                      <ReactToPrint content={() => this.componentRef}>
                        <PrintContextConsumer>
                          {({ handlePrint }) => (
                            <span className="pdf-icon" onClick={handlePrint} />
                          )}
                        </PrintContextConsumer>
                      </ReactToPrint>
                    </div>
                    <PreviewMilestone
                      bucketMilestoneCOS={setDraftDataForMilestone(
                        get(data, "bucketDataDTOList", [])
                      ).filter(item => item.bucketName !== "Cabinet Milestone")}
                      cabinetMilestone={
                        get(this.state.editProjectData, "implMode") == "PRIVATE"
                          ? false
                          : setDraftDataForMilestone(
                              get(data, "bucketDataDTOList", [])
                            ).find(
                              item => item.bucketName === "Cabinet Milestone"
                            )
                      }
                      forDownload={true}
                      data={data}
                      ref={el => (this.componentRef = el)}
                    />
                    {!!(
                      get(permission, "updateProjectStatus") &&
                      get(data, "editMilestone") &&
                      !get(permission, "canViewOnlyProject")
                    ) ? (
                      <div
                        className="hide-timeline-btn open-edit-btn"
                        onClick={() => {
                          this.setState({ showEditMilestone: true });
                        }}
                      >
                        {get(data, "projectMilestoneStatus") === "DRAFT"
                          ? "Edit Draft"
                          : "Update"}
                      </div>
                    ) : null}
                    <div
                      className="hide-timeline-btn hide-milestone-btn"
                      onClick={() => {
                        this.setState({ showMilestone: false });
                      }}
                    >
                      HIDE
                    </div>
                  </div>
                </div>
                {get(data, "sponsoredByCategory") === "CENTRAL" &&
                setDraftDataForMilestone(
                  get(data, "bucketDataDTOList", [])
                    .filter(
                      item =>
                        item.bucket && item.bucket.name === "Cabinet Milestone"
                    )
                    .slice(-1)
                ).length !== 0 &&
                !setDraftDataForMilestone(
                  get(data, "bucketDataDTOList", [])
                    .filter(
                      item =>
                        item.bucket && item.bucket.name === "Cabinet Milestone"
                    )
                    .slice(-1)
                )[0].disabled &&
                !setDraftDataForMilestone(
                  get(data, "bucketDataDTOList", [])
                    .filter(
                      item =>
                        item.bucket && item.bucket.name === "Cabinet Milestone"
                    )
                    .slice(-1)
                )[0].milestoneTableDataCOS.every(
                  item =>
                    item.milestoneDataCOS &&
                    item.milestoneDataCOS.every(milestone => milestone.disabled)
                ) &&
                get(this.state.editProjectData, "implMode") !== "PRIVATE" ? (
                  <div className="cabinet-accordion">
                    <div
                      className={`accordion-header ${
                        isOpen ? "accordion-open" : ""
                      }`}
                      onClick={this.toggleAccordion}
                    >
                      <div className="header-left">
                        {!isOpen && <Image src={cabinet_milestone_logo} />}
                        <span>Cabinet Milestones</span>
                      </div>

                      <div className="header-right">
                        {isOpen ? (
                          <Image src={accordian_up_arrow} />
                        ) : (
                          <Image src={accordian_down_arrow} />
                        )}
                      </div>
                    </div>

                    {isOpen && (
                      <div className="accordion-body">
                        <table className="cabinet-milestone-table">
                          <thead>
                            <tr>
                              <th rowSpan="2">S.No</th>
                              <th
                                rowSpan="2"
                                className="milestone-activity-column"
                              >
                                Measurable Milestone/Activity
                              </th>

                              <th colSpan="2">Scheduled date of start</th>
                              <th colSpan="2">Scheduled date of finish</th>

                              <th
                                rowSpan="2"
                                className="responsible-agency-column"
                              >
                                Responsible Agency/
                                <br />
                                Authority Involved
                              </th>

                              <th rowSpan="2">
                                Reason For
                                <br />
                                Delay
                              </th>

                              <th rowSpan="2">Status</th>
                            </tr>

                            <tr>
                              <th>Original</th>
                              <th className="revised-actual-header">
                                Revised/Actual
                              </th>
                              <th>Original</th>
                              <th className="revised-actual-header">
                                Revised/Actual
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {(() => {
                              const cabinetMilestone = setDraftDataForMilestone(
                                get(data, "bucketDataDTOList", [])
                              ).find(
                                item => item.bucketName === "Cabinet Milestone"
                              );

                              return (
                                cabinetMilestone &&
                                !cabinetMilestone.disabled &&
                                cabinetMilestone.milestoneTableDataCOS.length >
                                  0 &&
                                cabinetMilestone.milestoneTableDataCOS[0].milestoneDataCOS
                                  .filter(
                                    item =>
                                      (!item.timeDelay ||
                                        item.timeDelay.key !== "Disabled") &&
                                      // NEW: only show this milestone row if at least one of the
                                      // 4 date fields has been filled in. If all 4 are empty/null,
                                      // skip rendering the row entirely.
                                      (item.originalScheduledStartDate ||
                                        item.revisedScheduledStartDate ||
                                        item.originalScheduledFinishDate ||
                                        item.revisedScheduledFinishDate)
                                  )
                                  .map((item, index) => (
                                    <tr key={item.id}>
                                      <td>{index + 1}</td>

                                      <td>{item.milestone.name}</td>

                                      <td>
                                        {item.originalScheduledStartDate
                                          ? moment(
                                              item.originalScheduledStartDate
                                            ).format("DD/MM/YYYY")
                                          : "-"}
                                      </td>

                                      <td>
                                        {item.revisedScheduledStartDate
                                          ? moment(
                                              item.revisedScheduledStartDate
                                            ).format("DD/MM/YYYY")
                                          : "-"}
                                      </td>

                                      <td>
                                        {item.originalScheduledFinishDate
                                          ? moment(
                                              item.originalScheduledFinishDate
                                            ).format("DD/MM/YYYY")
                                          : "-"}
                                      </td>

                                      <td>
                                        {item.revisedScheduledFinishDate
                                          ? moment(
                                              item.revisedScheduledFinishDate
                                            ).format("DD/MM/YYYY")
                                          : "-"}
                                      </td>

                                      <td>
                                        {item.responsibleAuthorityName ===
                                        "Others"
                                          ? item.otherResponsibleAuthority ||
                                            "-"
                                          : item.responsibleAuthorityName}
                                      </td>

                                      <td>
                                        {item.reasonForDelay ? (
                                          <span
                                            className="cabinet-view-link"
                                            onClick={() =>
                                              this.openReasonModal(
                                                item.milestone.name,
                                                item.reasonForDelay
                                              )
                                            }
                                          >
                                            VIEW
                                          </span>
                                        ) : (
                                          "-"
                                        )}
                                      </td>

                                      <td>
                                        <span
                                          style={{
                                            minWidth:
                                              item.timeDelay &&
                                              item.timeDelay.key ===
                                                "Delay Expected"
                                                ? "110px"
                                                : item.timeDelay &&
                                                  item.timeDelay.key ===
                                                    "Delayed"
                                                ? "63px"
                                                : item.timeDelay &&
                                                  item.timeDelay.key ===
                                                    "Completed"
                                                ? "80px"
                                                : item.timeDelay &&
                                                  item.timeDelay.key ===
                                                    "On Track"
                                                ? "69px"
                                                : null
                                          }}
                                          className={
                                            item.timeDelay
                                              ? `cabinet-status ${
                                                  item.timeDelay.key ===
                                                  "Delayed"
                                                    ? "cabinet-status-delayed"
                                                    : item.timeDelay.key ===
                                                      "Disabled"
                                                    ? "cabinet-status-disabled"
                                                    : item.timeDelay.key ===
                                                      "Delay Expected"
                                                    ? "cabinet-status-delay-expected"
                                                    : item.timeDelay.key ===
                                                      "Completed"
                                                    ? "cabinet-status-completed"
                                                    : item.timeDelay.key ===
                                                      "On Track"
                                                    ? "cabinet-status-track"
                                                    : ""
                                                }`
                                              : ""
                                          }
                                        >
                                          {item.timeDelay
                                            ? item.timeDelay.key
                                            : "-"}
                                        </span>
                                      </td>
                                    </tr>
                                  ))
                              );
                            })()}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                ) : null}

                <div className="cabinet-accordion">
                  <div
                    className={`accordion-header ${
                      pmgAccordion ? "accordion-open" : ""
                    }`}
                    onClick={this.pmgToggleAccordion}
                  >
                    <div className="header-left">
                      {!pmgAccordion && <Image src={pmg_white_logo} />}
                      <span>PMG Milestones</span>
                    </div>

                    <div className="header-right">
                      {pmgAccordion ? (
                        <Image src={accordian_up_arrow} />
                      ) : (
                        <Image src={accordian_down_arrow} />
                      )}
                    </div>
                  </div>

                  {pmgAccordion && (
                    <div className="accordion-body">
                      <div className="milestone-toggle d-flex justify-content-between">
                        <ToggleBtn
                          checked={this.state.milestoneTabs}
                          uncheckedTitle={"OVERVIEW"}
                          checkedTitle={"DETAILS"}
                          callback={this.onProjectMilestoneByChangeResponsive}
                        />
                      </div>
                      {this.state.milestoneTabs === false && (
                        <div className="monthYearToggle">
                          <div className="d-flex">
                            <div className="d-flex">
                              <input
                                type="radio"
                                value="Month"
                                name="viewMode"
                                checked={
                                  this.state.selectedViewMode === "Month"
                                }
                                onChange={this.onViewModeChange}
                              />
                              <div className="toggleLabel ml-2">Month View</div>
                            </div>
                            <div className="d-flex ml-4">
                              <input
                                type="radio"
                                value="Year"
                                name="viewMode"
                                checked={this.state.selectedViewMode === "Year"}
                                onChange={this.onViewModeChange}
                              />
                              <div className="toggleLabel ml-2">Year View</div>
                            </div>
                          </div>
                        </div>
                      )}

                      <div class="gantt-chart mt-4">
                        {tasks.length && this.state.milestoneTabs === false ? (
                          <>
                            {this.state.selectedViewMode === "Month" && (
                              <Gantt
                                tasks={tasks.filter(
                                  item =>
                                    item && item.name !== "Cabinet Milestone"
                                )}
                                viewMode="Month"
                                rowHeight={43}
                                columnWidth={30}
                                barCornerRadius={0}
                                headerHeight={77}
                                TooltipContent={MilestoneTooltipContent}
                                TaskListHeader={taskListHeader}
                                TaskListTable={taskListTable}
                                barFill={60}
                              />
                            )}
                            {this.state.selectedViewMode === "Year" && (
                              <Gantt
                                tasks={tasks.filter(
                                  item =>
                                    item && item.name !== "Cabinet Milestone"
                                )}
                                viewMode="Year"
                                rowHeight={43}
                                columnWidth={132}
                                barCornerRadius={0}
                                headerHeight={45}
                                TooltipContent={MilestoneTooltipContent}
                                TaskListHeader={taskListDateHeader}
                                TaskListTable={taskListTable}
                                barFill={60}
                              />
                            )}
                            {representsDelay && (
                              <div className="representsDelay d-flex">
                                <div className="delay-icon ml-1 mt-1" />
                                <span className="representsDelaySpan ml-1">
                                  Represents Delay
                                </span>
                              </div>
                            )}
                            <div className="d-flex justify-content-end">
                              <div className="d-flex">
                                <div className="originalSchedule d-flex">
                                  <div className="originalScheduleBackground ml-1 my-auto" />
                                  <div className="text-center originalScheduleText pl-10">
                                    Original Schedule
                                  </div>
                                </div>
                                <div className="revisedSchedule d-flex ml-2">
                                  <div className="revisedScheduleContainer d-flex">
                                    <div className="revisedScheduleBackground ml-1 my-auto" />
                                    {representsDelay && (
                                      <div className="delayScheduleBackground my-auto" />
                                    )}
                                  </div>
                                  <div className="text-center revisedScheduleText">
                                    Revised Schedule
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/* <div> */}
                            <div className="border-top-stage" />
                            {get(data, "sponsoredByid") == 166 &&
                              Object.keys(this.state.costDistributionData)
                                .length !== 0 && (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between"
                                  }}
                                >
                                  <div className="state-wise-header">
                                    State-wise Progress
                                  </div>
                                  {phases &&
                                    phases.length > 1 &&
                                    get(data, "sponsoredByid") == 166 && (
                                      <Dropdown
                                        className="phase-dropdown"
                                        onSelect={key =>
                                          this.setState({
                                            activeIndex:
                                              key === "select" ? 0 : Number(key)
                                          })
                                        }
                                        style={{ background: "#FFFFFF" }}
                                      >
                                        <Dropdown.Toggle
                                          variant="Primary"
                                          id="dropdown-basic"
                                          className="dropDown-Toggle-alt"
                                        >
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "flex-end"
                                            }}
                                          >
                                            <span
                                              style={{
                                                width: "4rem",
                                                color: "black",
                                                fontFamily: "mpsb"
                                              }}
                                            >
                                              {this.state.activeIndex !== null
                                                ? `Phase ${this.state
                                                    .activeIndex + 1}`
                                                : "Select Phase"}
                                            </span>
                                            <img
                                              src={Dropdownarrow}
                                              className="arrowbtn"
                                              style={{
                                                marginLeft: 55,
                                                height: "9px",
                                                width: "20px",
                                                marginTop: 5
                                              }}
                                            />
                                          </div>
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu>
                                          <Dropdown.Item
                                            eventKey="select"
                                            active={
                                              this.state.activeIndex === null
                                            }
                                            style={{
                                              paddingLeft: "10px",
                                              color: "#848484",
                                              fontFamily: "mpsb"
                                            }}
                                          >
                                            Select Phase
                                            {/* </span> */}
                                          </Dropdown.Item>
                                          {phases &&
                                            phases.map((val, ind) => (
                                              <Dropdown.Item
                                                onClick={() =>
                                                  this.setState({
                                                    activeIndex: ind
                                                  })
                                                }
                                                className="phasedropD"
                                                key={ind}
                                                eventKey={ind}
                                                active={
                                                  this.state.activeIndex === ind
                                                }
                                              >
                                                Phase {ind + 1}
                                              </Dropdown.Item>
                                            ))}
                                        </Dropdown.Menu>
                                      </Dropdown>
                                    )}
                                </div>
                              )}
                            {get(data, "sponsoredByid") == 166 &&
                              (totalPhases >= 1 && hasValidData ? (
                                <div className="costDistributionCardArea">
                                  {this.state.costDistributionData[
                                    this.state.activeIndex
                                  ]
                                    .filter(
                                      val => val.totalLocationsConnected != null
                                    )
                                    .map((val, ind) => (
                                      <div className="costDistributionCard">
                                        <div className="stateOrUT" key={ind}>
                                          {val.stateOrUT}
                                        </div>
                                        <div className="otherElements">
                                          <span className="dataHeader">
                                            {val.totalLocationsConnectedHeader}
                                          </span>
                                          <span className="dataElements">
                                            {val.totalLocationsConnected +
                                              "/" +
                                              val.totalLocationsUncovered}
                                          </span>
                                        </div>
                                        <div className="otherElements">
                                          <span className="dataHeader">
                                            {val.totalOFCInstalledHeader}
                                          </span>
                                          <span className="dataElements">
                                            {val.totalOFCInstalled +
                                              "/" +
                                              val.totalOFCPlanned}
                                          </span>
                                        </div>
                                        <div className="otherElements">
                                          <span className="dataHeader">
                                            Total Project Cost
                                          </span>
                                          <span
                                            className="dataElements"
                                            style={{
                                              color: "#E14A2C",
                                              fontWeight: "600"
                                            }}
                                          >
                                            {"₹ " +
                                              val.totalProjectCost +
                                              " Cr."}
                                          </span>
                                        </div>
                                        <div className="otherElements">
                                          <span className="dataHeader">
                                            Implementation Agency
                                          </span>
                                          <span className="dataElements">
                                            {val.implementationAgency || ""}
                                          </span>
                                        </div>
                                        <div className="progressSection">
                                          <div className="otherElements">
                                            <span className="dataHeader">
                                              Physical Progress
                                            </span>
                                            <span
                                              className="dataElements"
                                              style={{
                                                color: "#E14A2C",
                                                fontWeight: "600"
                                              }}
                                            >
                                              {" "}
                                              {val.physicalProgressPercentage +
                                                "%"}
                                            </span>
                                          </div>
                                          <div style={{ padding: "5px 20px" }}>
                                            <progress
                                              className={`password-strength-statewise strength`}
                                              value={
                                                val.physicalProgressPercentage
                                              }
                                              max={100}
                                              style={{
                                                width: "-webkit-fill-available"
                                              }}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                </div>
                              ) : (
                                phases &&
                                phases.length > 1 && (
                                  <div style={{ margin: "10px 0 0 0" }}>
                                    <span
                                      style={{
                                        color: "#88A1C5",
                                        fontFamily: "mpb",
                                        fontSize: "15px"
                                      }}
                                    >
                                      NO DATA AVAILABLE
                                    </span>
                                  </div>
                                )
                              ))}
                          </>
                        ) : (
                          " "
                        )}
                      </div>
                      {this.state.milestoneTabs !== false && (
                        <ProjectMilestoneDetails
                          bucketMilestoneCOS={setDraftDataForMilestone(
                            get(data, "bucketDataDTOList", []).filter(
                              item =>
                                item.bucket &&
                                item.bucket.name !== "Cabinet Milestone"
                            )
                          )}
                          cabinetMilestone={
                            get(this.state.editProjectData, "implMode") ==
                            "PRIVATE"
                              ? false
                              : setDraftDataForMilestone(
                                  get(data, "bucketDataDTOList", [])
                                    .filter(
                                      item =>
                                        item.bucket &&
                                        item.bucket.name === "Cabinet Milestone"
                                    )
                                    .slice(-1)
                                )
                          }
                          projectMilestoneStatus={get(
                            data,
                            "projectMilestoneStatus"
                          )}
                          milestoneLastUpdatedBy={get(
                            data,
                            "milestoneLastUpdatedBy"
                          )}
                        />
                      )}
                    </div>
                  )}
                </div>
              </div>
            )
          ) : null}
        </Container>
      </React.Fragment>
    );
  }
}

ProjectDetails.propTypes = {
  location: PropTypes.shape({})
};

ProjectDetails.defaultProps = {
  location: {}
};

function mapStateToProps(state) {
  return {
    projectData: state.projectDetailsReducer.projectData,
    projectTimelineData: state.projectDetailsReducer.projectTimelineData,
    projectTimelineStatus: state.projectDetailsReducer.projectTimelineStatus,
    loading: state.projectDetailsReducer.projectDetailsStatus,
    isLoading: state.createProjectReducer.isLoading,
    projectStatusList: state.misReducer.projectStatusList,
    previewData: state.formReducer.previewData,
    projectDecisionData: state.projectDetailsReducer.projectAddDecisionData,
    projectAddDecisionStatus:
      state.projectDetailsReducer.projectAddDecisionStatus
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getProjectDetails: getProjectDetails,
      getIssueList: getIssueList,
      fetchAllProjectStatus: fetchAllProjectStatus,
      clearIssueListDispatch: clearIssueList,
      getProjectTimelineData,
      getMilestoneGanttChartData,
      getProjectDecisionDetailsDispatch: getProjectDecisionDetailsAction,
      setProjectDataDispatch: setProjectDataAction,
      getProjectDetailByIdDispatch: getProjectDetailByIdAction
    },
    dispatch
  );
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(PermissionHOC(ProjectDetails))
);
